/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"

// react
import { useContext, useEffect, useState, useRef } from "react"
import { Link, useHistory, useLocation, Prompt } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Button } from "react-bootstrap"
import { AppDispatch } from "../../.."

// others
import Decimal from "decimal.js"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"

// Kairos
import {
  showInfoToast,
  showWarningToast,
} from "../../../components/CustomToast"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import { T表紙分割 } from "../../../components/ComboBox/HyosiBunkatuComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { T請求内訳 } from "../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { ModalOuter } from "../../../components/Modal/ModalOuter"
import NinusiSeikyuSearchModal from "../../../components/SearchModal/NinusiSeikyuSearchModal"
import SyaryoSearchModal from "../../../components/SearchModal/SyaryoSearchModal"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import SiharaisakiSearchModal from "../../../components/SearchModal/SiharaisakiSearchModal"
import TumiOrosiSakiSearchModal from "../../../components/SearchModal/TumiOrosiSakiSearchModal"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import {
  IsSearchingContext,
  GridInitializedContext,
  IsRestoreSearchingContext,
  IsPromptRefContext,
} from "../../../components/Context"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import { nameofT } from "../../../ts/util/typeUtil"
import util from "../../../ts/util"
import CONSTANT from "../../../constant"
import { 区分分類コード } from "../../../constant/enum/codes"
import { メニューコード } from "../../../constant/menuCode"
import {
  e付替区分,
  e請求支払処理状態区分,
  e請求支払確認区分,
  e配車状態区分,
  e海コン付帯作業区分,
  e課税区分,
  T海コン工程区分名称,
} from "../../../constant/enum/zyutuHaisya"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import { TApiResponse } from "../../../service/TApiResponse"
import {
  TKaikonZyutyuHaisyaPatternListGetReq,
  TKaikonZyutyuHaisyaPatternListGetRes,
} from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/TKaikonZyutyuHaisyaPattern"
import KaikonZyutyuHaisyaPatternRegisterModal from "./KaikonZyutyuHaisyaPatternRegisterModal"
import KaikonZyutyuHaisyaPatternModal from "./KaikonZyutyuHaisyaPatternModal/KaikonZyutyuHaisyaPatternModal"
import {
  SearchConditionContext,
  SearchMethodContext,
  SearchResultContext,
  ZyutyubusyoContext,
} from "./KaikonZyutyuHaisyaListContext"
import { TKaikonZyutyuHaisyaListGetRes } from "../../../service/orderContainer/kaikonZyutyuHaisya/TKaikonZyutyuHaisya"
import KaikonZyutyuHaisyaService from "../../../service/orderContainer/kaikonZyutyuHaisya/kaikonZyutyuHaisyaService"
import {
  T傭車DataMap用Item,
  T支払先DataMap用Item,
  T車輌DataMap用Item,
} from "../../../type/gridDataMap"

import {
  PICKBindings,
  PICK車輌Bindings,
  PICK付帯Bindings,
  その他Bindings,
  その他車輌Bindings,
  その他付帯Bindings,
  オーダー情報Bindings,
  コンテナ情報Bindings,
  作業Bindings,
  作業車輌Bindings,
  作業付帯Bindings,
  支払Bindings,
  荷主Bindings,
  請求Bindings,
  返却Bindings,
  返却車輌Bindings,
  返却付帯Bindings,
  受領書Bindings,
  船舶情報Bindings,
} from "./KaikonZyutyuHaisyaListConstant"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import _ from "lodash"
import { RootState } from "../../../globalStore/rootreducer"
import KaikonZyutyuHaisyaPatternService from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/kaikonZyutyuHaisyaPatternService"
import dayjs from "dayjs"
import {
  TTumiorosisakiListGetRes,
  T積卸先,
} from "../../../service/master/tumiorosisaki/TTumiorosisaki"
import TumiorosisakiService from "../../../service/master/tumiorosisaki/tumiorosisakiService"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import commonUtil from "../../../ts/util/commonUtil"
import SyaryoService from "../../../service/truck/syaryoService"
import {
  get乗務員ItemsSourceByApi,
  get傭車itemsSourceFunctionByDataMap,
  get海コン一覧用車輌itemsSourceFunctionByDataMap,
  get積卸ItemsSourceByApi,
  get荷主ItemsSourceByApi,
  itemsSourceFunctionSearchOuterDataMap,
  傭車DisplayNameFunc,
  build車輌DataMapList,
} from "../../../ts/util/autoCompleteUtil"
import { 全部所車番検索Enabled } from "../../../constant/featureFlags"
import {
  castトレーラ傭車,
  castトレーラ車輌,
  castヘッド傭車,
  castヘッド車輌,
  cast乗務員,
  cast積卸先,
  clear運行情報,
  copy,
  setPattern,
  createコース編集 as createコース編集Inner,
} from "./KaikonZyutuHaisyaListGridUtil"
import { TNinusiInfoGetRes } from "../../../service/master/ninusi/TNinusi"
import { TZyutyuHaisyaListDeleteReq } from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import {
  is請求確認済,
  kaikonExcelFormat,
  受領書DataMap,
} from "../../../ts/util/haisyaUtil"
import dateUtil from "../../../ts/util/dateUtil"
import { decimalPlus } from "../../../ts/util/decimalUtil"
import { e支払先区分, e計上基準日区分 } from "../../../constant/enum/master"
import YosyaService from "../../../service/master/yosya/yosyaService"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"
import { T支払先 } from "../../../components/ComboBox/SiharaiSakiComboBox"
import YosyaSearchModal from "../../../components/SearchModal/YosyaSearchModal"
import { T傭車マスタ } from "../../../service/master/yosya/TYosya"
import { TZyomuinListItem } from "../../../service/driver/TZyomuin"
import { useGridEventHandler } from "../../../ts/hooks/useGridEventHandler"
import ZyomuinService from "../../../service/driver/zyomuinService"
import stringUtil from "../../../ts/util/stringUtil"

// #region [type]

export type T海コン受注配車入力GridItem = TKaikonZyutyuHaisyaListGetRes & {
  新規編集フラグ?: boolean
  isSelected?: boolean
  row_id: symbol
  bl受領書確認フラグ: boolean
}

export type T食事手当 = { name: string; value: number }

// #endregion

/**
 * 受注配車入力grid部
 * @param props
 * @returns
 */
const ZyutyuHaisyaListGrid: React.FC<{
  searchConditionClear?: React.MouseEventHandler<HTMLElement>
  gridId: string
}> = (props) => {
  const history = useHistory()
  const location = useLocation()

  const 受注配車入力PathList = util.getMenuPath(
    メニューコード.海コン受注配車.海コン_受注配車入力
  )

  //#region [context]
  const disPatch: AppDispatch = useDispatch()
  const 休日List = useSelector((state: RootState) => state.date.休日List)

  // ロード表示
  const { state: isSearching, setState: setIsSearching } =
    useContext(IsSearchingContext)
  //grid初期化フラグ
  const { state: gridInitialized, setState: setGridInitialized } = useContext(
    GridInitializedContext
  )
  // gridレストア完了フラグ
  const { state: isRestoreSearching, setState: setIsRestoreSearching } =
    useContext(IsRestoreSearchingContext)

  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  //#endregion
  // 検索結果
  const searchResult = useContext(SearchResultContext)
  const preSearchCondition = useContext(SearchConditionContext)
  const 受注部所コード = useContext(ZyutyubusyoContext)
  // 検索用メソッド
  const search = useContext(SearchMethodContext)
  //#endregion
  // 画面遷移制御
  const isPrompt = useContext(IsPromptRefContext)
  const [forceUpdate, setForceUpdate] = useState(false)

  //#region [state]
  //dataMap
  //表紙分割と請求内訳は動的生成
  const [表紙分割DataMap, set表紙分割DataMap] =
    useState<wjcGrid.DataMap<T表紙分割>>()
  const [表紙分割List, set表紙分割List] = useState<T表紙分割[]>([])
  const [請求内訳DataMap, set請求内訳DataMap] =
    useState<wjcGrid.DataMap<T請求内訳>>()
  const [請求内訳List, set請求内訳List] = useState<T請求内訳[]>([])

  const [運行部所DataMap, set運行部所DataMap] =
    useState<wjcGrid.DataMap<T部所マスタ>>()

  //区分系
  const [コンテナサイズDataMap, setコンテナサイズDataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [コンテナ軸DataMap, setコンテナ軸DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [配車状態区分DataMap, set配車状態区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [付帯作業分類区分DataMap, set付帯作業分類区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [付帯作業分類区分List, set付帯作業分類区分List] = useState<
    T区分マスタ[]
  >([])
  const [計上基準日区分DataMap, set計上基準日区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [食事手当区分DataMap, set食事手当区分DataMap] =
    useState<wjcGrid.DataMap<T食事手当>>()
  const [selectedRows, setSelectedRows] = useState<wjcGrid.Row[]>([])

  // 編集用選択行確保state
  const [選択行, set選択行] = useState<wjcGrid.Row>()
  const [is複写Modal, setIs複写Modal] = useState(false)
  const [
    is海コン受注配車パターン新規登録Modal,
    setIs海コン受注配車パターン新規登録Modal,
  ] = useState(false)

  const [isGridRefresh, setIsGridRefresh] = useState(false)
  const [isListGot, setIsListGot] = useState(false)

  const [
    is海コン受注配車パターン検索Modal,
    setIs海コン受注配車パターン検索Modal,
  ] = useState(false)
  const [部所List, set部所List] = useState<T部所マスタ[]>()
  const [select受注部所, setSelect受注部所] = useState<T部所マスタ>()
  // 荷主検索
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  // 積卸先検索
  const [is積卸先検索Modal, setIs積卸先検索Modal] = useState(false)
  const [工程検索対象, set工程検索対象] = useState<T海コン工程区分名称>("PICK")
  const [積卸先List, set積卸先List] = useState<T積卸先[]>([])

  const [乗務員List, set乗務員List] = useState<TZyomuinListItem[]>([])
  const [車輌検索対象, set車輌検索対象] = useState<"車輌" | "トレーラ">("車輌")

  const [モーダル検索用荷主コード, setモーダル検索用荷主コード] = useState<
    string | undefined
  >()
  const [モーダル検索用荷主名, setモーダル検索用荷主名] = useState<
    string | undefined
  >()
  // 車輌検索
  const [is車輌検索Modal, setIs車輌検索Modal] = useState(false)
  const [車輌DataList, set車輌DataList] = useState<T車輌DataMap用Item[]>()
  const [車輌DataMap, set車輌DataMap] = useState<
    wjcGrid.DataMap<{
      name: string
      value: number
    }>
  >()
  const [車輌検索用部所コード, set車輌検索用部所コード] = useState<string | undefined>()
  const [車輌検索用原動機有無フラグ, set車輌検索用原動機有無フラグ] = useState<
    0 | 1 | undefined
  >()

  const [is傭車検索Modal, setIs傭車検索Modal] = useState(false)
  const [車輌検索用傭車会社コード, set車輌検索用傭車会社コード] = useState<
    string | undefined
  >()

  const [傭車DataMap, set傭車DataMap] = useState<
    wjcGrid.DataMap<{
      name: string
      value: number
    }>
  >()

  const [支払先DataMap, set支払先DataMap] =
    useState<wjcGrid.DataMap<T支払先DataMap用Item>>()

  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)
  const [乗務員検索対象, set乗務員検索対象] = useState<"同乗者" | "乗務員">(
    "乗務員"
  )

  // 傭車先検索
  const [is傭車先検索Modal, setIs傭車先検索Modal] = useState(false)
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isDeleteConfirmModalShow, setIsDeleteConfirmModalShow] =
    useState(false)
  const [isDeleteRowConfirmModalShow, setIsDeleteRowConfirmModalShow] =
    useState(false)
  const [contextItem, setContextItem] = useState<T海コン受注配車入力GridItem>()
  const [is荷主コード変更, setIs荷主コード変更] = useState(false)

  const [isDisabled登録ボタン, setIsDisabled登録ボタン] = useState(false)

  // filter用
  const editedRowData = useRef<T海コン受注配車入力GridItem>()

  // エラーチェック用
  const 荷主コード未存在List = useRef<Symbol[]>([])
  const 表紙名未存在List = useRef<Symbol[]>([])
  //#endregion

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TKaikonZyutyuHaisyaListGetRes>,
    pageSize: number
  ) => {
    const newData: T海コン受注配車入力GridItem[] = data.map((d) => {
      return {
        ...d,
        row_id: Symbol(),
        bl受領書確認フラグ: d.受領書確認フラグ === 1,
      }
    })

    return new wjCore.CollectionView<T海コン受注配車入力GridItem>(newData, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        受注No: (data: T海コン受注配車入力GridItem) => {
          if (data.受注伝票番号 != null && data.受注伝票番号 !== "") {
            const text = `${data.受注伝票番号}${
              data.受注枝番 != null && data.受注枝番 > 0
                ? `-${data.受注枝番}`
                : data.複写フラグ === 1
                ? "-??"
                : ""
            }`
            return text
          } else {
            return ""
          }
        },
        paddingPICK車番: (data: T海コン受注配車入力GridItem) =>
          util.createPadding車番(data.PICK車番),
        paddingPICKトレーラ車番: (data: T海コン受注配車入力GridItem) =>
          util.createPadding車番(data.PICKトレーラ車番),
        padding作業車番: (data: T海コン受注配車入力GridItem) =>
          util.createPadding車番(data.作業車番),
        padding作業トレーラ車番: (data: T海コン受注配車入力GridItem) =>
          util.createPadding車番(data.作業トレーラ車番),
        padding返却車番: (data: T海コン受注配車入力GridItem) =>
          util.createPadding車番(data.返却車番),
        padding返却トレーラ車番: (data: T海コン受注配車入力GridItem) =>
          util.createPadding車番(data.返却トレーラ車番),
        paddingその他車番: (data: T海コン受注配車入力GridItem) =>
          util.createPadding車番(data.その他車番),
        paddingその他トレーラ車番: (data: T海コン受注配車入力GridItem) =>
          util.createPadding車番(data.その他トレーラ車番),
        padding請求車番: (data: T海コン受注配車入力GridItem) =>
          util.createPadding車番(data.請求車番),
        請求合計: (item: TKaikonZyutyuHaisyaListGetRes) =>
          new Decimal(item.請求高速料 ?? 0)
            .plus(item.請求付帯料 ?? 0)
            .plus(item.請求運送料 ?? 0)
            .toNumber(),

        支払合計: (item: TKaikonZyutyuHaisyaListGetRes) =>
          new Decimal(item.支払高速料 ?? 0)
            .plus(item.支払付帯料 ?? 0)
            .plus(item.支払運送料 ?? 0)
            .toNumber(),
        PICK支払先コード: (item: TKaikonZyutyuHaisyaListGetRes) => {
          if (item.PICK傭車フラグ === 1) {
            return item.支払先コード
          } else {
            return null
          }
        },
        作業支払先コード: (item: TKaikonZyutyuHaisyaListGetRes) => {
          if (item.作業傭車フラグ === 1) {
            return item.支払先コード
          } else {
            return null
          }
        },
        返却支払先コード: (item: TKaikonZyutyuHaisyaListGetRes) => {
          if (item.返却傭車フラグ === 1) {
            return item.支払先コード
          } else {
            return null
          }
        },
        その他支払先コード: (item: TKaikonZyutyuHaisyaListGetRes) => {
          if (item.その他傭車フラグ === 1) {
            return item.支払先コード
          } else {
            return null
          }
        },
        PICK傭車会社名: (item: TKaikonZyutyuHaisyaListGetRes) => {
          if (item.PICK傭車フラグ === 1) {
            return item.傭車会社名
          } else {
            return null
          }
        },
        作業傭車会社名: (item: TKaikonZyutyuHaisyaListGetRes) => {
          if (item.作業傭車フラグ === 1) {
            return item.傭車会社名
          } else {
            return null
          }
        },
        返却傭車会社名: (item: TKaikonZyutyuHaisyaListGetRes) => {
          if (item.返却傭車フラグ === 1) {
            return item.傭車会社名
          } else {
            return null
          }
        },
        その他傭車会社名: (item: TKaikonZyutyuHaisyaListGetRes) => {
          if (item.その他傭車フラグ === 1) {
            return item.傭車会社名
          } else {
            return null
          }
        },
      },
    })
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    // 休日リストがすでに入力されていた場合formatItemとbeginEditのイベントとも付与する
    if (休日List && 休日List.length > 0) {
      grid.formatItem.addHandler(formatItem)
      grid.beginningEdit.addHandler(beginningEdit)
    }
    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (荷主Bindings.includes(c.binding)) {
          setHeaderText = "荷主"
        } else if (コンテナ情報Bindings.includes(c.binding)) {
          setHeaderText = "コンテナ情報"
        } else if (オーダー情報Bindings.includes(c.binding)) {
          setHeaderText = "オーダー情報"
        } else if (PICKBindings.includes(c.binding)) {
          setHeaderText = "PICK"
        } else if (PICK車輌Bindings.includes(c.binding)) {
          setHeaderText = "PICK車輌"
        } else if (PICK付帯Bindings.includes(c.binding)) {
          setHeaderText = "PICK付帯"
        } else if (作業Bindings.includes(c.binding)) {
          setHeaderText = "作業"
        } else if (作業車輌Bindings.includes(c.binding)) {
          setHeaderText = "作業車輌"
        } else if (作業付帯Bindings.includes(c.binding)) {
          setHeaderText = "作業付帯"
        } else if (返却Bindings.includes(c.binding)) {
          setHeaderText = "返却"
        } else if (返却車輌Bindings.includes(c.binding)) {
          setHeaderText = "返却車輌"
        } else if (返却付帯Bindings.includes(c.binding)) {
          setHeaderText = "返却付帯"
        } else if (その他Bindings.includes(c.binding)) {
          setHeaderText = "その他"
        } else if (その他車輌Bindings.includes(c.binding)) {
          setHeaderText = "その他車輌"
        } else if (その他付帯Bindings.includes(c.binding)) {
          setHeaderText = "その他付帯"
        } else if (請求Bindings.includes(c.binding)) {
          setHeaderText = "請求"
        } else if (支払Bindings.includes(c.binding)) {
          setHeaderText = "支払"
        } else if (受領書Bindings.includes(c.binding)) {
          setHeaderText = "受領書"
        } else if (船舶情報Bindings.includes(c.binding)) {
          setHeaderText = "船舶情報"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        c.align = "left"
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
  }

  const get荷主 = async (荷主コード: string) => {
    try {
      const res = await new NinusiService().getList({ 荷主コード })
      if (res && res.data && res.data.length > 0) {
        return res.data[0]
      } else {
        return null
      }
    } catch (error) {
      disPatch(setAlerts(error))
      return null
    }
  }

  // #region [gridHandler]
  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let dataItem: T海コン受注配車入力GridItem = e.getRow().dataItem
    editedRowData.current = dataItem
    const cellBinding = e.getColumn()
      .binding as keyof T海コン受注配車入力GridItem
    if (
      cellBinding !== null &&
      !cellBinding.includes("返却") &&
      !cellBinding.includes("その他")
    ) {
      if (is請求確認済(dataItem)) {
        e.cancel = true
        return
      }
    }
    // 傭車フラグがたっている作業工程では以下の項目は入力不可とする
    // 乗務員売上・付帯作業分類
    switch (cellBinding) {
      case "PICK乗務員売上額":
      case "PICK付帯作業区分コード":
        e.cancel = dataItem.PICK傭車フラグ === 1
        break
      case "作業乗務員売上額":
      case "作業付帯作業区分コード":
        e.cancel = dataItem.作業傭車フラグ === 1
        break
      case "返却乗務員売上額":
      case "返却付帯作業区分コード":
        e.cancel = dataItem.返却傭車フラグ === 1
        break
      case "その他乗務員売上額":
      case "その他付帯作業区分コード":
        e.cancel = dataItem.その他傭車フラグ === 1
        break
      default:
        break
    }
  }
  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = async (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]
    if (e.cancel === true) {
      return
    }
    let newValue = s.getCellData(e.row, e.col, false)
    let dataItem: T海コン受注配車入力GridItem = e.getRow().dataItem
    const colBindingName = col.binding as keyof T海コン受注配車入力GridItem
    switch (colBindingName) {
      case nameofT<T海コン受注配車入力GridItem>("荷主コード"):
        if (
          dataItem.荷主コード ||
          dataItem.オーダー内容 ||
          dataItem.オーダー備考 ||
          dataItem.オーダー指定時間 ||
          dataItem.荷主依頼番号 ||
          dataItem.コンテナNO ||
          dataItem.コンテナサイズコード ||
          dataItem.コンテナ軸コード
        ) {
          dataItem.新規編集フラグ = false
        }
        if (col.editor == null) return
        const 荷主Editor = col.editor as wjcInput.AutoComplete
        const 荷主selectedItem = 荷主Editor.selectedItem as TNinusiInfoGetRes
        if (荷主selectedItem == null) {
          dataItem.荷主コード = ""
          dataItem.荷主ID = undefined
          dataItem.荷主名 = undefined
          dataItem.荷主略称1 = undefined
        } else {
          dataItem.荷主コード = 荷主selectedItem.荷主コード
          dataItem.荷主ID = 荷主selectedItem.荷主ID
          dataItem.荷主名 = 荷主selectedItem.荷主名
          dataItem.荷主略称1 = 荷主selectedItem.荷主略称1
          if (!dataItem.荷主依頼番号) {
            dataItem.荷主依頼番号 = 荷主selectedItem.荷主依頼番号接頭辞
          }
        }
        s.refresh()
        setIs荷主コード変更(true)

        break
      case nameofT<T海コン受注配車入力GridItem>("荷主請求ID"):
        if (newValue === e.data) return

        // 変更時は荷主請求内訳を消去する
        dataItem.荷主請求内訳ID = undefined
        dataItem.計上基準日区分名称1 = undefined
        dataItem.計上基準日区分コード = undefined
        dataItem.請求車番 = undefined
        dataItem.請求計上日 = undefined
        // 税込高速料を埋める
        if (newValue != null) {
          const 荷主請求: T表紙分割 = col.dataMap?.getDataItem(newValue)
          if (荷主請求) {
            dataItem.表紙名 = 荷主請求.表紙名
            dataItem.請求高速料税込区分コード = 荷主請求.高速料税込区分コード
            dataItem.請求高速料税込区分名称1 = 荷主請求.高速料税込区分名称1
          } else {
            dataItem.表紙名 = ""
          }
        }
        break
      case nameofT<T海コン受注配車入力GridItem>("オーダー内容"):
      case nameofT<T海コン受注配車入力GridItem>("オーダー備考"):
      case nameofT<T海コン受注配車入力GridItem>("オーダー指定時間"):
      case nameofT<T海コン受注配車入力GridItem>("荷主依頼番号"):
      case nameofT<T海コン受注配車入力GridItem>("コンテナNO"):
      case nameofT<T海コン受注配車入力GridItem>("コンテナサイズコード"):
      case nameofT<T海コン受注配車入力GridItem>("コンテナ軸コード"):
        if (
          dataItem.オーダー内容 ||
          dataItem.オーダー備考 ||
          dataItem.オーダー指定時間 ||
          dataItem.荷主依頼番号 ||
          dataItem.コンテナNO ||
          dataItem.コンテナサイズコード ||
          dataItem.コンテナ軸コード
        ) {
          dataItem.新規編集フラグ = false
        }
        break
      case "PICK積卸先コード":
      case "作業積卸先コード":
      case "返却積卸先コード":
      case "その他積卸先コード":
        // 空文字やnull undefinedのときはスルー
        if (col.editor == null) return
        const 積卸先Editor = col.editor as wjcInput.AutoComplete
        const 積卸先selectedItem =
          積卸先Editor.selectedItem as TTumiorosisakiListGetRes
        const binding = col.binding as keyof TKaikonZyutyuHaisyaListGetRes
        switch (binding) {
          case "PICK積卸先コード":
            if (col.editor == null) return
            cast積卸先(dataItem, 積卸先selectedItem, "PICK")
            break
          case "作業積卸先コード":
            if (col.editor == null) return
            cast積卸先(dataItem, 積卸先selectedItem, "作業")
            break
          case "返却積卸先コード":
            if (col.editor == null) return
            cast積卸先(dataItem, 積卸先selectedItem, "返却")
            break
          case "その他積卸先コード":
            if (col.editor == null) return
            cast積卸先(dataItem, 積卸先selectedItem, "その他")
            break
        }
        s.refresh()
        break
      case nameofT<T海コン受注配車入力GridItem>("荷主請求内訳ID"):
        if (dataItem.荷主請求内訳ID) {
          const 請求内訳 = 請求内訳List?.find(
            (i) => i.荷主請求内訳ID === dataItem.荷主請求内訳ID
          )
          console.log(請求内訳)
          if (請求内訳) {
            // 計上基準日区分を自動で入れる
            dataItem.計上基準日区分名称1 = 請求内訳.計上基準日区分名称1
            dataItem.計上基準日区分コード = 請求内訳.計上基準日区分コード
          } else {
            dataItem.計上基準日区分名称1 = ""
            dataItem.計上基準日区分コード = ""
          }
        } else {
          dataItem.計上基準日区分名称1 = ""
          dataItem.計上基準日区分コード = ""
        }
        break
      case nameofT<T海コン受注配車入力GridItem>("受注配車パターンコード"):
        // 空文字やnull undefinedのときはスルー
        // autoCOmpleteのバグ？なのかselectedValueではなく、displayMemberPathの値が入ってきてしまうため、
        // 現在のeditorを直接参照し、値を詰め込むようにする。
        if (col.editor == null) return
        const cellEditor = col.editor as wjcInput.AutoComplete

        if (cellEditor.selectedItem != null) {
          await setPattern(cellEditor.selectedItem, dataItem)
          setIsListGot(true)
          setIs荷主コード変更(true)
          setIsGridRefresh(true)
        } else {
          // 文字列と完全一致するものがあったら登録
          if (cellEditor.text != null && cellEditor.text !== "") {
            const autoCompleteItems = cellEditor.collectionView
              .sourceCollection as TKaikonZyutyuHaisyaPatternListGetRes[]
            const targetPattern = autoCompleteItems.find(
              (i) =>
                i.受注配車パターンコード === cellEditor.text &&
                i.受注部所コード === 受注部所コード
            )
            if (targetPattern) {
              await setPattern(targetPattern, dataItem)
              setIsGridRefresh(true)
            }
          }
        }
        s.refresh()
        break
      case nameofT<T海コン受注配車入力GridItem>("PICK車番"):
      case nameofT<T海コン受注配車入力GridItem>("作業車番"):
      case nameofT<T海コン受注配車入力GridItem>("返却車番"):
      case nameofT<T海コン受注配車入力GridItem>("その他車番"):
        const 工程区分string = colBindingName.replaceAll(
          "車番",
          ""
        ) as T海コン工程区分名称
        const 傭車フラグPropertyName:
          | "PICK傭車フラグ"
          | "作業傭車フラグ"
          | "返却傭車フラグ"
          | "その他傭車フラグ" = `${工程区分string}傭車フラグ`
        if (col.editor == null) return
        const 車輌cellEditor = col.editor as wjcInput.AutoComplete
        // 傭車かどうかで分岐
        if (dataItem[傭車フラグPropertyName] === 1) {
          const 傭車 = 車輌cellEditor.selectedItem as T傭車DataMap用Item
          castヘッド傭車(dataItem, 傭車, 工程区分string)
        } else {
          const 車輌 = 車輌cellEditor.selectedItem as T車輌DataMap用Item
          castヘッド車輌(dataItem, 車輌, 工程区分string)
        }
        dataItem.請求車番 = 請求車番入力(dataItem)
        s.refresh()
        break
      case "PICKトレーラ車番":
      case "作業トレーラ車番":
      case "返却トレーラ車番":
      case "その他トレーラ車番":
        {
          const 工程区分string = colBindingName.replaceAll(
            "車番",
            ""
          ) as T海コン工程区分名称
          const 傭車フラグPropertyName:
            | "PICK傭車フラグ"
            | "作業傭車フラグ"
            | "返却傭車フラグ"
            | "その他傭車フラグ" = `${工程区分string}傭車フラグ`

          if (col.editor == null) return
          const トレーラ車輌cellEditor = col.editor as wjcInput.AutoComplete
          // 傭車かどうかで分岐
          if (dataItem[傭車フラグPropertyName] === 1) {
            const トレーラ傭車 =
              トレーラ車輌cellEditor.selectedItem as T傭車DataMap用Item
            castトレーラ傭車(dataItem, トレーラ傭車, 工程区分string)
          } else {
            const トレーラ車輌 =
              トレーラ車輌cellEditor.selectedItem as T車輌DataMap用Item
            castトレーラ車輌(dataItem, トレーラ車輌, 工程区分string)
          }

          s.refresh()
        }
        break
      case "PICK付帯作業手当":
      case "作業付帯作業手当":
      case "返却付帯作業手当":
      case "その他付帯作業手当":
        dataItem.請求付帯料 =
          (dataItem.PICK付帯作業手当 ?? 0) +
          (dataItem.作業付帯作業手当 ?? 0) +
          (dataItem.返却付帯作業手当 ?? 0) +
          (dataItem.その他付帯作業手当 ?? 0)
        break
      case "PICK付帯作業区分コード":
      case "作業付帯作業区分コード":
      case "返却付帯作業区分コード":
      case "その他付帯作業区分コード":
        if (!dataItem.請求備考) {
          const 付帯作業区分コード =
            dataItem.PICK付帯作業区分コード ??
            dataItem.作業付帯作業区分コード ??
            dataItem.返却付帯作業区分コード ??
            dataItem.その他付帯作業区分コード ??
            null
          if (
            付帯作業区分コード &&
            付帯作業区分コード !== e海コン付帯作業区分.フォーク作業
          ) {
            dataItem.請求備考 = 付帯作業分類区分List.filter(
              (d) => d.区分コード === 付帯作業区分コード
            )[0].名称1
          }
        }
        switch (col.binding) {
          case "PICK付帯作業区分コード":
            if (
              dataItem.PICK付帯作業区分コード &&
              dataItem.PICK付帯作業区分コード !==
                e海コン付帯作業区分.フォーク作業
            ) {
              dataItem.PICK付帯作業手当 = 付帯作業分類区分List.filter(
                (d) => d.区分コード === dataItem.PICK付帯作業区分コード
              )[0].数値1
            }
            break
          case "作業付帯作業区分コード":
            if (
              dataItem.作業付帯作業区分コード &&
              dataItem.作業付帯作業区分コード !==
                e海コン付帯作業区分.フォーク作業
            ) {
              dataItem.作業付帯作業手当 = 付帯作業分類区分List.filter(
                (d) => d.区分コード === dataItem.作業付帯作業区分コード
              )[0].数値1
            }
            break
          case "返却付帯作業区分コード":
            if (
              dataItem.返却付帯作業区分コード &&
              dataItem.返却付帯作業区分コード !==
                e海コン付帯作業区分.フォーク作業
            ) {
              dataItem.返却付帯作業手当 = 付帯作業分類区分List.filter(
                (d) => d.区分コード === dataItem.返却付帯作業区分コード
              )[0].数値1
            }
            break
          case "その他付帯作業区分コード":
            if (
              dataItem.その他付帯作業区分コード &&
              dataItem.その他付帯作業区分コード !==
                e海コン付帯作業区分.フォーク作業
            ) {
              dataItem.その他付帯作業手当 = 付帯作業分類区分List.filter(
                (d) => d.区分コード === dataItem.その他付帯作業区分コード
              )[0].数値1
            }
            break
        }
        // 請求付帯料再計算

        dataItem.請求付帯料 =
          (dataItem.PICK付帯作業手当 ?? 0) +
          (dataItem.作業付帯作業手当 ?? 0) +
          (dataItem.返却付帯作業手当 ?? 0) +
          (dataItem.その他付帯作業手当 ?? 0)
        break
      case "PICK海コン付帯高速料":
      case "作業海コン付帯高速料":
      case "返却海コン付帯高速料":
      case "その他海コン付帯高速料":
        dataItem.請求高速料 = decimalPlus([
          dataItem.PICK海コン付帯高速料,
          dataItem.作業海コン付帯高速料,
          dataItem.返却海コン付帯高速料,
          dataItem.その他海コン付帯高速料,
        ])
        break
      case "PICK支払先コード":
      case "作業支払先コード":
      case "返却支払先コード":
      case "その他支払先コード":
      case "作業作業日":
        // 一つでも傭車フラグがあった場合、作業日の入力があれば支払計上日を設定する
        if (
          dataItem.PICK傭車フラグ ||
          dataItem.作業傭車フラグ ||
          dataItem.返却傭車フラグ ||
          dataItem.その他傭車フラグ
        ) {
          if (dataItem.作業作業日 != null && dataItem.作業作業日 !== "") {
            dataItem.支払計上日 = dataItem.作業作業日
          }
        }
        break
      case "PICK乗務員名":
      case "作業乗務員名":
      case "返却乗務員名":
      case "その他乗務員名":
      case "PICK同乗者名":
      case "作業同乗者名":
      case "返却同乗者名":
      case "その他同乗者名":
        // 支払先ID(傭車会社)が入っているときは特に処理しない
        // 支払先IDが入っている場合、IDは消去されている
        if (dataItem.支払先ID != null || col.editor == null) return
        const 乗務員Editor = col.editor as wjcInput.AutoComplete
        const 乗務員selectedItem = 乗務員Editor.selectedItem as TZyomuinListItem
        const 工程区分 = colBindingName
          .replaceAll("乗務員名", "")
          .replaceAll("同乗者名", "") as T海コン工程区分名称
        if (乗務員selectedItem != null) {
          if (colBindingName.includes("乗務員名")) {
            cast乗務員(dataItem, 乗務員selectedItem, "乗務員", 工程区分)
          } else {
            cast乗務員(dataItem, 乗務員selectedItem, "同乗者", 工程区分)
          }
        } else {
          //一件のときはそのデータを入れる
          let 乗務員selectedItem: TZyomuinListItem | null
          if (乗務員Editor.collectionView.sourceCollection.length === 1) {
            乗務員selectedItem = 乗務員Editor.collectionView
              .sourceCollection[0] as TZyomuinListItem
          } else {
            乗務員selectedItem = null
          }
          if (colBindingName.includes("乗務員名")) {
            cast乗務員(dataItem, 乗務員selectedItem, "乗務員", 工程区分)
          } else {
            cast乗務員(dataItem, 乗務員selectedItem, "同乗者", 工程区分)
          }
        }
        s.refresh()
        break
      case "PICK傭車フラグ":
      case "作業傭車フラグ":
      case "返却傭車フラグ":
      case "その他傭車フラグ": {
        // booleanのため、0| 1に変換
        dataItem[colBindingName] = dataItem[colBindingName] ? 1 : 0

        const 工程区分 = colBindingName.replaceAll(
          "傭車フラグ",
          ""
        ) as T海コン工程区分名称
        // 1に変更の場合、ID入りの項目はすべて消す
        if (!e.cancel && dataItem[colBindingName] === 1) {
          clear運行情報(dataItem, 工程区分)
        }
        s.refresh()
        break
      }
      case "bl受領書確認フラグ":
        dataItem.受領書確認フラグ = dataItem.bl受領書確認フラグ ? 1 : 0
        break
      default:
        break
    }
    // 作業日と請求計上日連動用のswitch文
    // 作業作業日に他と違う処理が混じっているが連動処理は同一で記載したいためここに記載
    // 今編集完了した物が計上基準日区分の作業日で、かつ請求計上日が空欄の場合登録する
    // 請求計上日が空欄ではない場合そもそもスルーする
    switch (colBindingName) {
      case "PICK作業日":
        if (dataItem.計上基準日区分コード === e計上基準日区分.PICK日) {
          dataItem.請求計上日 = dataItem.PICK作業日
        }
        break
      case "作業作業日":
        if (dataItem.計上基準日区分コード === e計上基準日区分.作業日) {
          dataItem.請求計上日 = dataItem.作業作業日
        }
        break
      case "返却作業日":
        if (dataItem.計上基準日区分コード === e計上基準日区分.返却日) {
          dataItem.請求計上日 = dataItem.返却作業日
        }
        break
      //その他は計上基準日区分として存在しない
      default:
        break
    }

    editedRowData.current = undefined

    s?.refresh()
  }

  /**
   * セル編集完了時イベント
   */
  const pastedCell = async (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]
    if (e.cancel === true) {
      return
    }
    console.log(e.data)
    let dataItem: T海コン受注配車入力GridItem = e.getRow().dataItem
    const colBindingName = col.binding as keyof T海コン受注配車入力GridItem
    switch (colBindingName) {
      case "PICK乗務員名":
      case "作業乗務員名":
      case "返却乗務員名":
      case "その他乗務員名":
      case "PICK同乗者名":
      case "作業同乗者名":
      case "返却同乗者名":
      case "その他同乗者名":
        const 工程区分 = colBindingName
          .replaceAll("乗務員名", "")
          .replaceAll("同乗者名", "") as T海コン工程区分名称

        const 傭車フラグPropName = (工程区分 + "傭車フラグ") as
          | "PICK傭車フラグ"
          | "作業傭車フラグ"
          | "返却傭車フラグ"
          | "その他傭車フラグ"

        // 傭車の場合は処理しない
        if (dataItem[傭車フラグPropName] === 1) break

        const 対象乗務員List = 乗務員List.filter((z) =>
          stringUtil.compareWithoutWhiteSpace(
            z.社員氏名,
            dataItem[colBindingName]
          )
        )

        if (対象乗務員List.length === 1) {
          if (colBindingName.includes("乗務員名")) {
            cast乗務員(dataItem, 対象乗務員List[0], "乗務員", 工程区分)
          } else {
            cast乗務員(dataItem, 対象乗務員List[0], "同乗者", 工程区分)
          }
        } else if (!wjCore.isNullOrWhiteSpace(dataItem[colBindingName] ?? "")) {
          showWarningToast(
            "正確な乗務員を取得できないため、入力できませんでした。"
          )
          if (colBindingName.includes("乗務員名")) {
            cast乗務員(dataItem, null, "乗務員", 工程区分)
          } else {
            cast乗務員(dataItem, null, "同乗者", 工程区分)
          }
        }
        break
      case "PICK付帯作業手当":
      case "作業付帯作業手当":
      case "返却付帯作業手当":
      case "その他付帯作業手当":
        dataItem.請求付帯料 =
          (dataItem.PICK付帯作業手当 ?? 0) +
          (dataItem.作業付帯作業手当 ?? 0) +
          (dataItem.返却付帯作業手当 ?? 0) +
          (dataItem.その他付帯作業手当 ?? 0)
        break
      case "PICK海コン付帯高速料":
      case "作業海コン付帯高速料":
      case "返却海コン付帯高速料":
      case "その他海コン付帯高速料":
        dataItem.請求高速料 = decimalPlus([
          dataItem.PICK海コン付帯高速料,
          dataItem.作業海コン付帯高速料,
          dataItem.返却海コン付帯高速料,
          dataItem.その他海コン付帯高速料,
        ])
        break
      default:
        break
    }

    s?.refresh()
  }

  const cellEditEnding = async (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellEditEndingEventArgs
  ) => {
    // キャンセルの場合処理しない
    let col = s.columns[e.col]
    let dataItem = e.getRow().dataItem as T海コン受注配車入力GridItem
    const binding = col.binding as keyof T海コン受注配車入力GridItem
    // if (e.cancel) return
    switch (binding) {
      case "荷主コード": // 入力内容がnullもしくは空白のとき検索しない
        if (
          s.activeEditor.value == null ||
          wjCore.isNullOrWhiteSpace(s.activeEditor.value ?? "")
        ) {
          dataItem.荷主名 = ""
          dataItem.荷主略称1 = ""
          dataItem.荷主ID = undefined
        } else {
          get荷主(s.activeEditor.value).then((荷主) => {
            if (荷主) {
              dataItem.荷主名 = 荷主.荷主名
              dataItem.荷主ID = 荷主.荷主ID
              dataItem.荷主略称1 = 荷主.荷主略称1
              if (!dataItem.荷主依頼番号) {
                dataItem.荷主依頼番号 = 荷主.荷主依頼番号接頭辞
              }
              setIs荷主コード変更(true)
            }
          })
        }
        break

      case "受注配車パターンコード":
        // 空文字やnull undefinedのときはスルー
        if (
          s.activeEditor.value == null ||
          wjCore.isNullOrWhiteSpace(s.activeEditor.value ?? "")
        )
          return
        const condition: TKaikonZyutyuHaisyaPatternListGetReq = {
          受注配車パターンコード: s.activeEditor.value,
        }
        try {
          const service = new KaikonZyutyuHaisyaPatternService()
          const res = await service.getList(condition)
          if (res.data.length === 1) {
            await setPattern(res.data[0], dataItem)
            setIsListGot(true)

            setIs荷主コード変更(true)
            setIsGridRefresh(true)
          }
        } catch (error) {
          disPatch(setAlerts(error))
        }
        break
      case "PICK積卸先名称":
      case "PICK積卸先市区町村":
        // 修正前と値が変更になっていた場合idを消去する
        if (s.activeEditor.value !== e.data && dataItem.PICK積卸先ID != null) {
          dataItem.PICK積卸先ID = undefined
        }
        break
      case "作業積卸先名称":
      case "作業積卸先市区町村":
        // 修正前と値が変更になっていた場合idを消去する
        if (s.activeEditor.value !== e.data && dataItem.作業積卸先ID != null) {
          dataItem.作業積卸先ID = undefined
        }
        break
      case "返却積卸先名称":
      case "返却積卸先市区町村":
        // 修正前と値が変更になっていた場合idを消去する
        if (s.activeEditor.value !== e.data && dataItem.返却積卸先ID != null) {
          dataItem.返却積卸先ID = undefined
        }
        break
      case "その他積卸先名称":
      case "その他積卸先市区町村":
        // 修正前と値が変更になっていた場合idを消去する
        if (
          s.activeEditor.value !== e.data &&
          dataItem.その他積卸先ID != null
        ) {
          dataItem.その他積卸先ID = undefined
        }
        break
      case "PICK支払先コード":
      case "作業支払先コード":
      case "返却支払先コード":
      case "その他支払先コード":
        const 工程区分string = binding.replaceAll(
          "支払先コード",
          ""
        ) as T海コン工程区分名称
        const 傭車フラグPropertyName:
          | "PICK傭車フラグ"
          | "作業傭車フラグ"
          | "返却傭車フラグ"
          | "その他傭車フラグ" = `${工程区分string}傭車フラグ`

        if (
          s.activeEditor == null ||
          s.activeEditor.value === "" ||
          s.activeEditor.value === null
        ) {
          dataItem[傭車フラグPropertyName] = 0
        } else {
          dataItem.支払先コード = s.activeEditor.value
          if (col.editor) {
            const colEditor = col.editor as wjcInput.AutoComplete
            const 支払先: T支払先 = colEditor.selectedItem
            dataItem.支払先ID = 支払先.支払先ID
            dataItem.支払先コード = 支払先.支払先コード
            dataItem.傭車会社名 = 支払先.支払先名
            clear運行情報(dataItem, 工程区分string)
          }

          dataItem[傭車フラグPropertyName] = 1
        }

        break
    }
    // 庸車フラグが全て立っていない場合は支払先コードを消す
    if (
      !dataItem.PICK傭車フラグ &&
      !dataItem.作業傭車フラグ &&
      !dataItem.返却傭車フラグ &&
      !dataItem.その他傭車フラグ
    ) {
      dataItem.支払先コード = undefined
      dataItem.傭車会社名 = undefined
    } else {
      // 一つでも傭車フラグがあった場合、作業日の入力があれば支払計上日を設定する
      switch (col.binding as keyof T海コン受注配車入力GridItem) {
        case "PICK支払先コード":
        case "作業支払先コード":
        case "返却支払先コード":
        case "その他支払先コード":
        case "作業作業日":
          if (dataItem.作業作業日 != null && dataItem.作業作業日 !== "") {
            dataItem.支払計上日 = dataItem.作業作業日
          }
          break
        default:
          break
      }
    }
  }

  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn()
        .binding as keyof T海コン受注配車入力GridItem
      const targetRow = e.getRow()
      const dataItem: T海コン受注配車入力GridItem = e.getRow().dataItem
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
        //請求額確認済みの行はreadonly
        if (!cellBinding.includes("返却") && !cellBinding.includes("その他")) {
          if (is請求確認済(dataItem)) {
            wjCore.toggleClass(e.cell, "read-only-cell", true)
            return
          }
        }
        // 【設計意図】選択行（isSelected=true）のみ編集可能にする制御。
        // 同等の選択行ガードは setGridReadOnly（useEffect 経由で React state の selectedRows を参照）にも存在するが、
        // ここで dataItem.isSelected を直接参照するのは「新規行追加（addRow）・行差替え（補完Listからの復元）後の
        // refresh 時にも cssClass / isReadOnly を自動初期化する」役割を担うため。
        // 新規行追加経路は dataItem.isSelected = true をセットするのみで cssClass を直接 set しておらず、
        // この formatItem が初期化を引き受けている前提になっている。
        // setGridReadOnly 側は加えて「請求確認済行を真に編集不可（Wijmo Row.isReadOnly）にする」責務を持ち、
        // ここで上書きされないよう formatItem 上段（1290-1301 付近）で早期 return している。両者は残置が必要。
        // ※パフォーマンス上は行プロパティをセル単位で 243 回 set している点が課題（KIROS_DEV-467 Phase 1 対象）。
        targetRow.cssClass = dataItem.isSelected ? "edit-row" : ""
        targetRow.isReadOnly = !dataItem.isSelected
        switch (cellBinding as keyof T海コン受注配車入力GridItem) {
          case "荷主コード":
            if (
              荷主コード未存在List.current != null &&
              荷主コード未存在List.current.length > 0
            ) {
              const is未存在 = 荷主コード未存在List.current.find(
                (d) => d === dataItem.row_id
              )
                ? true
                : false
              wjCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            if (!dataItem.コンテナNO || !dataItem.荷主コード) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            } else {
              wjCore.toggleClass(e.cell, "kotei-cell-color-default", true)
            }
            break
          case "受注配車パターンコード":
          case "荷主請求ID":
          case "オーダー内容":
          case "オーダー備考":
          case "オーダー指定時間":
          case "荷主依頼番号":
          case "コンテナNO":
          case "コンテナサイズコード":
          case "コンテナ軸コード":
          case "配車状態区分コード":
            if (!dataItem.コンテナNO || !dataItem.荷主コード) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            } else {
              wjCore.toggleClass(e.cell, "kotei-cell-color-default", true)
            }
            break
          case "PICK積卸先名称":
          case "PICK積卸先市区町村":
          case "PICK積卸先都道府県":
            // idが存在する場合赤文字に設定
            wjCore.toggleClass(
              e.cell,
              "text-primary",
              dataItem.PICK積卸先ID == null
            )
            if (
              dataItem.PICK作業日 &&
              (!dataItem.PICK積卸先名称 ||
                !dataItem.PICK車番 ||
                !dataItem.PICK乗務員名)
            ) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            } else {
              wjCore.toggleClass(e.cell, "kotei-cell-color-21", true)
            }
            break
          case "PICK作業日":
          case "PICKカット日":
          case "PICK作業時間":
          case "PICK積卸先コード":
          case "PICK運行部所コード":
          case "PICK支払先コード":
          case "PICK傭車会社名":
          case "PICK傭車フラグ":
          case "PICK車番":
          case "PICKトレーラ車番":
          case "PICK乗務員名":
          case "PICK乗務員売上額":
          case "PICK海コン付帯高速料":
          case "PICK乗務員食事手当":
          case "PICK同乗者名":
          case "PICK付帯作業区分コード":
          case "PICK付帯作業手当":
          case "PICK工程備考":
            if (
              dataItem.PICK作業日 &&
              (!dataItem.PICK積卸先名称 ||
                !dataItem.PICK車番 ||
                !dataItem.PICK乗務員名)
            ) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            } else {
              wjCore.toggleClass(e.cell, "kotei-cell-color-21", true)
            }
            break
          case "作業積卸先名称":
          case "作業積卸先市区町村":
          case "作業積卸先都道府県":
            // idが存在する場合赤文字に設定
            wjCore.toggleClass(
              e.cell,
              "text-primary",
              dataItem.作業積卸先ID == null
            )
            if (
              dataItem.作業作業日 &&
              (!dataItem.作業積卸先名称 ||
                !dataItem.作業車番 ||
                !dataItem.作業乗務員名)
            ) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            } else {
              wjCore.toggleClass(e.cell, "kotei-cell-color-22", true)
            }
            break
          case "作業作業日":
          case "作業作業時間":
          case "作業積卸先コード":
          case "作業運行部所コード":
          case "作業支払先コード":
          case "作業傭車フラグ":
          case "作業傭車会社名":
          case "作業車番":
          case "作業トレーラ車番":
          case "作業乗務員名":
          case "作業乗務員売上額":
          case "作業海コン付帯高速料":
          case "作業乗務員食事手当":
          case "作業同乗者名":
          case "作業付帯作業区分コード":
          case "作業付帯作業手当":
          case "作業内容":
          case "作業工程備考":
            if (
              dataItem.作業作業日 &&
              (!dataItem.作業積卸先名称 ||
                !dataItem.作業車番 ||
                !dataItem.作業乗務員名)
            ) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            } else {
              wjCore.toggleClass(e.cell, "kotei-cell-color-22", true)
            }
            break
          case "返却積卸先名称":
          case "返却積卸先市区町村":
          case "返却積卸先都道府県":
            // idが存在する場合赤文字に設定
            wjCore.toggleClass(
              e.cell,
              "text-primary",
              dataItem.返却積卸先ID == null
            )
            if (
              dataItem.返却作業日 &&
              (!dataItem.返却積卸先名称 ||
                !dataItem.返却車番 ||
                !dataItem.返却乗務員名)
            ) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            } else {
              wjCore.toggleClass(e.cell, "kotei-cell-color-23", true)
            }
            break
          case "返却作業時間":
          case "返却積卸先コード":
          case "返却運行部所コード":
          case "返却支払先コード":
          case "返却傭車フラグ":
          case "返却傭車会社名":
          case "返却車番":
          case "返却トレーラ車番":
          case "返却乗務員名":
          case "返却乗務員売上額":
          case "返却海コン付帯高速料":
          case "返却乗務員食事手当":
          case "返却同乗者名":
          case "返却付帯作業区分コード":
          case "返却付帯作業手当":
          case "返却工程備考":
            if (
              dataItem.返却作業日 &&
              (!dataItem.返却積卸先名称 ||
                !dataItem.返却車番 ||
                !dataItem.返却乗務員名)
            ) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            } else {
              wjCore.toggleClass(e.cell, "kotei-cell-color-23", true)
            }
            break
          case "返却作業日":
          case "返却カット日":
            let mainCellBackGroundColorClassName = "kotei-cell-color-23"
            if (
              dataItem.返却作業日 &&
              (!dataItem.返却積卸先名称 ||
                !dataItem.返却車番 ||
                !dataItem.返却乗務員名)
            ) {
              mainCellBackGroundColorClassName =
                "kotei-cell-color-ContainerNull"
            }
            wjCore.toggleClass(e.cell, mainCellBackGroundColorClassName, true)

            // 返却作業日が空で返却カット日に入力があった場合文字を赤くする
            const has返却時カット日Error =
              wjCore.isNullOrWhiteSpace(dataItem.返却作業日 ?? "") &&
              !wjCore.isNullOrWhiteSpace(dataItem.返却カット日 ?? "")

            //カット日に入力してある日付より、返却日に入力されている日付のほうが遅い場合
            // カット日・返却日を赤背景にする
            const has返却日カット日逆転Error =
              !wjCore.isNullOrWhiteSpace(dataItem.返却作業日 ?? "") &&
              !wjCore.isNullOrWhiteSpace(dataItem.返却カット日 ?? "") &&
              dayjs(dataItem.返却作業日).diff(
                dayjs(dataItem.返却カット日),
                "D"
              ) > 0

            wjCore.toggleClass(
              e.cell,
              "input-date-warning",
              has返却時カット日Error || has返却日カット日逆転Error
            )
            // エラー特にない場合のバックグラウンドカラー設定

            wjCore.toggleClass(e.cell, "background", has返却日カット日逆転Error)

            if (cellBinding === "返却カット日") {
              wjCore.toggleClass(e.cell, "text", has返却時カット日Error)
            }

            break
          case "その他積卸先名称":
          case "その他積卸先市区町村":
          case "その他積卸先都道府県":
            // idが存在する場合赤文字に設定
            wjCore.toggleClass(
              e.cell,
              "text-primary",
              dataItem.その他積卸先ID == null
            )
            if (
              dataItem.その他作業日 &&
              (!dataItem.その他積卸先名称 ||
                !dataItem.その他車番 ||
                !dataItem.その他乗務員名)
            ) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            } else {
              wjCore.toggleClass(e.cell, "kotei-cell-color-24", true)
            }
            break
          case "その他作業日":
          case "その他作業時間":
          case "その他積卸先コード":
          case "その他運行部所コード":
          case "その他傭車フラグ":
          case "その他支払先コード":
          case "その他傭車会社名":
          case "その他車番":
          case "その他トレーラ車番":
          case "その他乗務員名":
          case "その他乗務員売上額":
          case "その他海コン付帯高速料":
          case "その他乗務員食事手当":
          case "その他同乗者名":
          case "その他付帯作業区分コード":
          case "その他付帯作業手当":
          case "その他作業内容":
          case "その他工程備考":
            if (
              dataItem.その他作業日 &&
              (!dataItem.その他積卸先名称 ||
                !dataItem.その他車番 ||
                !dataItem.その他乗務員名)
            ) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            } else {
              wjCore.toggleClass(e.cell, "kotei-cell-color-24", true)
            }
            break
          // case "請求高速料税込区分名称1":
          // case "請求高速料":
          // case "請求額確認区分名称1":
          // case "計上基準日区分コード":
          // case "請求付帯料":
          case "荷主請求内訳ID":
          case "請求車番":
          case "請求運送料課税区分コード":
          case "請求運送料":
          case "請求付帯料課税区分コード":
          case "請求計上日":
          case "請求備考":
          case "支払運送料":
          case "支払付帯料":
          case "支払高速料":
          case "支払計上日":
          case "支払備考":
            if (dataItem.isSelected) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-ContainerNull", true)
            }
            break

          // 船舶情報（KAIROS-1107で追加）: 選択（編集）行のみ白背景にして編集可能を示す。
          // toggleClass の第3引数に undefined を渡すとクラスがトグル（反転）され、
          // 初期表示（isSelected 未設定＝undefined）で白セルが出るため、必ず boolean に変換する。
          case "船社":
          case "BLBK":
          case "本船名":
          case "VOY":
            wjCore.toggleClass(
              e.cell,
              "kotei-cell-color-ContainerNull",
              dataItem.isSelected === true
            )
            break

          default:
            break
        }
        // 作業日セルは休日の場合色を変える
        if (
          ["PICK作業日", "作業作業日", "返却作業日", "その他作業日"].includes(
            cellBinding
          )
        ) {
          const cellData = dataItem[cellBinding] as string
          const checkNumber = dateUtil.HolidayCheck(cellData, 休日List)
          wjCore.toggleClass(e.cell, "date-sunday", checkNumber === 1)
          wjCore.toggleClass(e.cell, "date-holiday", checkNumber === 2)
        }
      }
    }
  }
  //#endregion

  //#region [gridEditHandler]

  const 積卸先AutoCompleteProperties = {
    minLength: 1,
    isEditable: true,
    delay: 10,
    itemsSourceFunction: (
      query: string,
      max: number,
      callback: wjcInput.IGetItemsCallback
    ) => {
      const 荷主コード = editedRowData.current?.荷主コード
      if (荷主コード == null || 荷主コード === "") {
        callback([])
        return
      }
      return get積卸ItemsSourceByApi(query, max, callback, 荷主コード)
    },
    displayMemberPath: "displayName",
    selectedValuePath: "積卸先コード",
  }

  const 車輌AutoCompleteProperties = {
    itemsSource: 車輌DataMap?.collectionView,
    minLength: 1,
    delay: 10,
    headerPath: "車番",
    showDropDownButton: false,
    displayMemberPath: "displayName",
    selectedValuePath: "車番",
  }

  /**
   * 車輌AutoCompleteのgotFocusハンドラー
   * 工程毎にプロパティ名が若干違うため、
   * 工程の文字列を外出しし、そこ以外を共通化
   * @param 工程
   * @returns
   */
  const 車輌AutoCompleteGotFocusHandler =
    (工程: T海コン工程区分名称) =>
    (原動機有無: 0 | 1) =>
    (control: wjcInput.AutoComplete) => {
      const rowDataItem = editedRowData.current
      const 傭車フラグPropertyNames =
        `${工程}傭車フラグ` as keyof T海コン受注配車入力GridItem
      const 運行部所コードPropertyNames:
        | "PICK運行部所コード"
        | "作業運行部所コード"
        | "返却運行部所コード"
        | "その他運行部所コード" = `${工程}運行部所コード`
      const 傭車フラグ = rowDataItem
        ? rowDataItem[傭車フラグPropertyNames]
        : undefined
      control.isEditable = 傭車フラグ === 1
      let itemsSourceFunction: wjcInput.IGetItems
      if (rowDataItem != null && 傭車フラグ === 1) {
        itemsSourceFunction = get傭車itemsSourceFunctionByDataMap(
          傭車DataMap,
          原動機有無,
          editedRowData.current ? editedRowData.current.支払先ID : undefined
        )
      } else {
        itemsSourceFunction = (
          query: string,
          max: number,
          callback: wjcInput.IGetItemsCallback
        ) =>
          get海コン一覧用車輌itemsSourceFunctionByDataMap(
            query,
            max,
            callback,
            原動機有無,
            車輌DataMap,
            editedRowData.current
              ? editedRowData.current[運行部所コードPropertyNames]
              : undefined
          )
      }
      control.itemsSourceFunction = itemsSourceFunction
    }

  const PICKヘッド車輌AutoCompleteGotFocusHandler =
    車輌AutoCompleteGotFocusHandler("PICK")(1)
  const PICKトレーラ車輌AutoCompleteGotFocusHandler =
    車輌AutoCompleteGotFocusHandler("PICK")(0)
  const 作業ヘッド車輌AutoCompleteGotFocusHandler =
    車輌AutoCompleteGotFocusHandler("作業")(1)
  const 作業トレーラ車輌AutoCompleteGotFocusHandler =
    車輌AutoCompleteGotFocusHandler("作業")(0)
  const 返却ヘッド車輌AutoCompleteGotFocusHandler =
    車輌AutoCompleteGotFocusHandler("返却")(1)
  const 返却トレーラ車輌AutoCompleteGotFocusHandler =
    車輌AutoCompleteGotFocusHandler("返却")(0)
  const その他ヘッド車輌AutoCompleteGotFocusHandler =
    車輌AutoCompleteGotFocusHandler("その他")(1)
  const その他トレーラ車輌AutoCompleteGotFocusHandler =
    車輌AutoCompleteGotFocusHandler("その他")(0)

  const PICKヘッド車輌AutoCompleteProperties = {
    ...車輌AutoCompleteProperties,
    gotFocus: PICKヘッド車輌AutoCompleteGotFocusHandler,
  }
  const PICKトレーラ車輌AutoCompleteProperties = {
    ...車輌AutoCompleteProperties,
    gotFocus: PICKトレーラ車輌AutoCompleteGotFocusHandler,
  }
  const 作業ヘッド車輌AutoCompleteProperties = {
    ...車輌AutoCompleteProperties,
    gotFocus: 作業ヘッド車輌AutoCompleteGotFocusHandler,
  }
  const 作業トレーラ車輌AutoCompleteProperties = {
    ...車輌AutoCompleteProperties,
    gotFocus: 作業トレーラ車輌AutoCompleteGotFocusHandler,
  }
  const 返却ヘッド車輌AutoCompleteProperties = {
    ...車輌AutoCompleteProperties,
    gotFocus: 返却ヘッド車輌AutoCompleteGotFocusHandler,
  }
  const 返却トレーラ車輌AutoCompleteProperties = {
    ...車輌AutoCompleteProperties,
    gotFocus: 返却トレーラ車輌AutoCompleteGotFocusHandler,
  }
  const その他ヘッド車輌AutoCompleteProperties = {
    ...車輌AutoCompleteProperties,
    gotFocus: その他ヘッド車輌AutoCompleteGotFocusHandler,
  }
  const その他トレーラ車輌AutoCompleteProperties = {
    ...車輌AutoCompleteProperties,
    gotFocus: その他トレーラ車輌AutoCompleteGotFocusHandler,
  }

  const 車輌検索ModalButtonClickHandler =
    (工程: typeof 工程検索対象) =>
    (原動機有無: 0 | 1) =>
    (context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>) =>
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault()
      set選択行(context.row)
      set工程検索対象(工程)
      set車輌検索対象(原動機有無 === 1 ? "車輌" : "トレーラ")
      set車輌検索用原動機有無フラグ(原動機有無)
      if (!全部所車番検索Enabled) set車輌検索用部所コード(context.item.運行部所コード)
      set車輌検索用傭車会社コード(context.item.支払先コード)
      const 傭車PropertyName:
        | "PICK傭車フラグ"
        | "作業傭車フラグ"
        | "返却傭車フラグ"
        | "その他傭車フラグ" = `${工程}傭車フラグ`
      if (context.item[傭車PropertyName] === 1) {
        setIs傭車検索Modal(true)
      } else {
        setIs車輌検索Modal(true)
      }
    }

  const PICKヘッド車輌検索ModalButtonClickHandler =
    車輌検索ModalButtonClickHandler("PICK")(1)
  const PICKトレーラ車輌検索ModalButtonClickHandler =
    車輌検索ModalButtonClickHandler("PICK")(0)
  const 作業ヘッド車輌検索ModalButtonClickHandler =
    車輌検索ModalButtonClickHandler("作業")(1)
  const 作業トレーラ車輌検索ModalButtonClickHandler =
    車輌検索ModalButtonClickHandler("作業")(0)
  const 返却ヘッド車輌検索ModalButtonClickHandler =
    車輌検索ModalButtonClickHandler("返却")(1)
  const 返却トレーラ車輌検索ModalButtonClickHandler =
    車輌検索ModalButtonClickHandler("返却")(0)
  const その他ヘッド車輌検索ModalButtonClickHandler =
    車輌検索ModalButtonClickHandler("その他")(1)
  const その他トレーラ車輌検索ModalButtonClickHandler =
    車輌検索ModalButtonClickHandler("その他")(0)

  const 傭車検索結果Set = (傭車: T傭車マスタ) => {
    if (選択行 && 選択行.dataItem) {
      const casted: T海コン受注配車入力GridItem = 選択行.dataItem
      switch (車輌検索用原動機有無フラグ) {
        case 1:
          // 有 車輌
          castヘッド傭車(casted, 傭車, 工程検索対象)
          break
        case 0:
          castトレーラ傭車(casted, 傭車, 工程検索対象)
          break
        default:
          break
      }
      flexGrid?.refresh()
    }
  }

  const 乗務員同乗者AutoCompleteProperties: (
    工程区分: T海コン工程区分名称
  ) => (
    propertyName: "乗務員名" | "同乗者名"
  ) => React.ComponentProps<typeof wjrInput.AutoComplete> =
    (工程区分) => (propertyName) => ({
      minLength: 1,
      headerPath: "社員氏名",
      isEditable: true,
      delay: 10,
      gotFocus: (control: wjcInput.AutoComplete) => {
        // クリック時に前回の入力値が消えるのでtextの埋めなおし
        const rowData = editedRowData.current
        control.text = rowData ? rowData[propertyName] ?? "" : ""
        control.isEditable = rowData?.支払先ID != null
      },
      itemsSourceFunction: (
        query: string,
        max: number,
        callback: wjcInput.IGetItemsCallback
      ) => {
        if (!editedRowData.current) {
          callback([])
          return
        }
        //運行部所と傭車フラグを確認する
        const 運行部所PropertyName:
          | "PICK運行部所コード"
          | "作業運行部所コード"
          | "返却運行部所コード"
          | "その他運行部所コード" = `${工程区分}運行部所コード`
        const 傭車フラグPropertyName:
          | "PICK傭車フラグ"
          | "作業傭車フラグ"
          | "返却傭車フラグ"
          | "その他傭車フラグ" = `${工程区分}傭車フラグ`
        const 部所コード = editedRowData.current[運行部所PropertyName]
        const 傭車フラグ = editedRowData.current[傭車フラグPropertyName]
        if (部所コード == null || 部所コード === "" || 傭車フラグ === 1) {
          callback([])
          return
        }
        return get乗務員ItemsSourceByApi(query, max, callback, 部所コード)
      },
      displayMemberPath: "displayName",
      selectedValuePath: "社員氏名",
    })

  const PICK乗務員AutoCompleteProperties =
    乗務員同乗者AutoCompleteProperties("PICK")("乗務員名")
  const PICK同乗者AutoCompleteProperties =
    乗務員同乗者AutoCompleteProperties("PICK")("同乗者名")
  const 作業乗務員AutoCompleteProperties =
    乗務員同乗者AutoCompleteProperties("作業")("乗務員名")
  const 作業同乗者AutoCompleteProperties =
    乗務員同乗者AutoCompleteProperties("作業")("同乗者名")
  const 返却乗務員AutoCompleteProperties =
    乗務員同乗者AutoCompleteProperties("返却")("乗務員名")
  const 返却同乗者AutoCompleteProperties =
    乗務員同乗者AutoCompleteProperties("返却")("同乗者名")
  const その他乗務員AutoCompleteProperties =
    乗務員同乗者AutoCompleteProperties("その他")("乗務員名")
  const その他同乗者AutoCompleteProperties =
    乗務員同乗者AutoCompleteProperties("その他")("同乗者名")

  const 傭車CDAutoCompleteProperties = {
    itemsSource: 支払先DataMap?.collectionView,
    headerPath: "支払先コード",
    minLength: 1,
    delay: 10,
    itemsSourceFunction: (
      query: string,
      max: number,
      callback: wjcInput.IGetItemsCallback
    ) =>
      itemsSourceFunctionSearchOuterDataMap(
        query,
        max,
        callback,
        支払先DataMap,
        "支払先コード",
        true
      ),
    displayMemberPath: "displayName",
    selectedValuePath: "支払先コード",
  }

  //#endregion

  /**
   * 複写イベント
   * 選択行を別受注もしくは枝番追加で複写する
   * @param {*} e
   */
  const 複写 = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    複製type: "枝番" | "別受注"
  ) => {
    if (flexGrid == null || selectedRows == null || selectedRows.length <= 0)
      return
    const addDataList: T海コン受注配車入力GridItem[] = []
    const selectedRowIds = flexGrid?.rows
      .filter(
        (r) =>
          r != null &&
          r.dataItem != null &&
          r.dataItem.row_id != null &&
          selectedRows.find((row) => row.dataItem.row_id === r.dataItem.row_id)
      )
      .map((row) => row.dataItem.row_id)

    selectedRows.forEach((row) => {
      const item: TKaikonZyutyuHaisyaListGetRes = row.dataItem
      // 新規行の複写はしない
      if (item.複写フラグ === 1) return
      const newRowId = Symbol()

      const newData = copy(item, newRowId)
      if (複製type === "別受注") newData.受注伝票番号 = undefined
      newData.受注枝番 = 0
      addDataList.push(newData)
      selectedRowIds.push(newRowId)
    })

    gridData.data.beginUpdate()
    addDataList.forEach((newData) => {
      gridData.data.addNew(newData)
    })
    gridData.data.commitNew()
    gridData.data.endUpdate()

    // 新規行含めた選択行再登録
    const newSelectRows: wjcGrid.Row[] = []

    flexGrid?.refresh()
    flexGrid?.rows.forEach((row) => {
      if (row.dataItem.row_id == null) return
      if (selectedRowIds?.find((sr) => sr === row.dataItem.row_id)) {
        newSelectRows.push(row)
        row.dataItem.isSelected = true
      }
    })
    setSelectedRows([...newSelectRows])
    setIsDisabled登録ボタン(false)
  }

  /**
   * 新規行追加
   */
  const addRow = () => {
    const newSelectRows: wjcGrid.Row[] = []
    // 選択状態の保持
    const selectedRowIds = flexGrid?.rows
      .filter(
        (r) =>
          r != null &&
          r.dataItem != null &&
          r.dataItem.row_id != null &&
          selectedRows.find((row) => row.dataItem.row_id === r.dataItem.row_id)
      )
      .map((row) => row.dataItem.row_id)
    const newRowId = Symbol()
    const newItem: Partial<T海コン受注配車入力GridItem> = {
      row_id: newRowId,
      isSelected: true,
      受注配車ID: 0,
      荷主コード: "",
      受注部所コード: userInfo.部所コード,
      複写フラグ: 1,
      新規編集フラグ: true,
      PICK運行部所コード:
        userInfo.運行部所フラグ === 1 ? userInfo.部所コード : undefined,
      作業運行部所コード:
        userInfo.運行部所フラグ === 1 ? userInfo.部所コード : undefined,
      返却運行部所コード:
        userInfo.運行部所フラグ === 1 ? userInfo.部所コード : undefined,
      その他運行部所コード:
        userInfo.運行部所フラグ === 1 ? userInfo.部所コード : undefined,
      請求付帯料課税区分コード: e課税区分.課税,
      請求運送料課税区分コード: e課税区分.課税,
    }
    gridData.data.beginUpdate()
    gridData.data.addNew(newItem)
    gridData.data.commitNew()
    gridData.data.endUpdate()
    const newRow = flexGrid?.rows.find(
      (r) => r.dataItem.row_id && r.dataItem.row_id === newRowId
    )
    if (newRow) {
      newSelectRows.push(newRow)
    }
    flexGrid?.rows.forEach((row) => {
      if (row.dataItem.row_id == null) return
      if (selectedRowIds?.find((sr) => sr === row.dataItem.row_id)) {
        newSelectRows.push(row)
        // formatItem (line 1302-) は dataItem.isSelected を判定ソースにしているため、
        // Wijmo Row.isSelected ではなく dataItem 側を更新する必要がある。
        row.dataItem.isSelected = true
      }
    })
    flexGrid?.refresh()
    isPrompt.current = true
    setSelectedRows([...newSelectRows])
    setIsDisabled登録ボタン(false)
  }

  const createコース編集 = (dataItem: TKaikonZyutyuHaisyaListGetRes) => {
    let コース編集Text = createコース編集Inner({
      PICK情報: dataItem.PICK作業日
        ? {
            積卸先名: dataItem.PICK積卸先名称,
            積卸先市区町村: dataItem.PICK積卸先市区町村,
          }
        : null,
      作業情報: dataItem.作業作業日
        ? {
            積卸先名: dataItem.作業積卸先名称,
            積卸先市区町村: dataItem.作業積卸先市区町村,
          }
        : null,
      返却情報: dataItem.返却作業日
        ? {
            積卸先名: dataItem.返却積卸先名称,
            積卸先市区町村: dataItem.返却積卸先市区町村,
          }
        : null,
      その他情報: dataItem.その他作業日
        ? {
            積卸先名: dataItem.その他積卸先名称,
            積卸先市区町村: dataItem.その他積卸先市区町村,
          }
        : null,
    })

    if (wjCore.isNullOrWhiteSpace(コース編集Text)) return
    return コース編集Text
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    clearError()
    let messages: string[] = []
    let isError = false
    const gridItems: T海コン受注配車入力GridItem[] = gridData.data.items
    const putData: T海コン受注配車入力GridItem[] = []
    gridItems.forEach((d) => {
      // 複写フラグがある行は選択していなくても登録する
      if (d.複写フラグ) {
        putData.push(d)
      }
    })
    if (selectedRows) {
      selectedRows.forEach((row) => {
        if (!row.dataItem.複写フラグ) {
          const item: T海コン受注配車入力GridItem = row.dataItem
          putData.push(item)
        }
      })
    }
    // 必須チェック
    const 必須Valid = 必須validate(putData)
    isError = 必須Valid.hasError === true ? true : isError
    messages.push(...必須Valid.messages)

    if (isError) {
      disPatch(setWarningAlerts(messages))
      flexGrid?.refresh()
      return
    }
    setIsConfirmModalShow(true)
  }

  const 工程情報validate = (rowItem: TKaikonZyutyuHaisyaListGetRes) => {
    //TODO: 積情報の日付が入ってない場合にエラー
    let 工程情報エラー = false
    let エラーメッセージ = ""
    if (
      !rowItem.PICK作業日 &&
      !rowItem.作業作業日 &&
      !rowItem.返却作業日 &&
      !rowItem.その他作業日
    ) {
      工程情報エラー = true
      エラーメッセージ = "PICK,作業,返却,その他のいずれかの日付は必須入力です"
    }

    return {
      hasError: 工程情報エラー,
      messages: エラーメッセージ,
    }
  }
  /**
   * エラークリア
   */
  const clearError = () => {
    disPatch(clearAlert())
  }

  /**
   * 必須チェック
   * @param putData: T受注配車入力GridItem[]
   */
  const 必須validate = (putData: T海コン受注配車入力GridItem[]) => {
    let 必須エラー = false
    let 表紙名エラー = false
    let 荷主コードエラー = false
    let 請求内訳エラー = false
    const エラーメッセージList: string[] = []

    if (受注部所コード == null || 受注部所コード === "") {
      必須エラー = true
      エラーメッセージList.push("受注部所は必須入力です")
    }
    // グリッド内の必須確認
    // TODO: schemaを使ったチェックに変更予定
    putData.forEach((d) => {
      if (d.荷主コード == null || d.荷主コード === "") {
        if (!荷主コードエラー) {
          荷主コードエラー = true
          エラーメッセージList.push("荷主コードは必須入力です")
        }
        荷主コード未存在List.current.push(d.row_id)
      }
      if (d.荷主請求ID == null) {
        if (!表紙名エラー) {
          表紙名エラー = true
          エラーメッセージList.push("表紙名は必須入力です")
        }
        表紙名未存在List.current.push(d.row_id)
      }
      if (d.荷主請求内訳ID == null) {
        if (!請求内訳エラー) {
          請求内訳エラー = true
          エラーメッセージList.push("請求内訳は必須入力です")
        }
        表紙名未存在List.current.push(d.row_id)
      }
    })
    return {
      hasError: 必須エラー || 表紙名エラー || 荷主コードエラー,
      messages: エラーメッセージList,
    }
  }

  /**
   * グリッド登録
   * @param gridData
   */
  const gridRegister = async () => {
    try {
      const gridItems: T海コン受注配車入力GridItem[] = gridData.data.items
      const putData: TKaikonZyutyuHaisyaListGetRes[] = []
      gridItems.forEach((d) => {
        // 配車状態区分が空もしくは未配車かつ車輌が登録されていた場合、自動的に配車確定に変更
        let d配車状態区分コード = d.配車状態区分コード
        // 新規の場合は初期値を海コン未配車にする
        if (!d.受注配車ID) {
          d配車状態区分コード = e配車状態区分.海コン未配車
        }
        if (
          d配車状態区分コード == null ||
          d配車状態区分コード === "" ||
          d配車状態区分コード === e配車状態区分.海コン未配車
        ) {
          if (
            (!d.PICK作業日 || (d.PICK作業日 && d.PICK車番)) &&
            (!d.作業作業日 || (d.作業作業日 && d.作業車番)) &&
            (!d.返却作業日 || (d.返却作業日 && d.返却車番)) &&
            (!d.その他作業日 || (d.その他作業日 && d.その他車番))
          ) {
            d配車状態区分コード = e配車状態区分.手配済
          }
        }
        d.配車状態区分コード = d配車状態区分コード
        // 受注部所は検索項目
        d.受注部所コード = 受注部所コード
        d.表紙名 = d.荷主請求ID?.toString()
        d.運行部所コード = d.PICK作業日
          ? d.PICK運行部所コード
          : d.作業作業日
          ? d.作業運行部所コード
          : d.返却作業日
          ? d.返却運行部所コード
          : d.その他作業日
          ? d.その他運行部所コード
          : undefined
        // 複写フラグがある行は選択していなくても登録する
        if (d.複写フラグ === 1) {
          if (d.受注部所コード === d.運行部所コード) {
            d.付替区分コード = e付替区分.自部所
          } else {
            d.付替区分コード = e付替区分.他部所
          }
          d.受領書有無フラグ = d.受領書有無フラグ ?? 0

          putData.push(d)
        }
      })
      if (selectedRows) {
        selectedRows.forEach((row) => {
          if (!row.dataItem.複写フラグ) {
            const item: TKaikonZyutyuHaisyaListGetRes = row.dataItem
            putData.push(item)
          }
        })
      }
      if (putData) {
        disPatch(clearAlert())
        let messages: string[] = []
        let isError = false
        putData.forEach((d) => {
          // 登録対象行は変更の有無にかかわらず、最新の積卸情報でコース編集を再作成する（一般受注配車と同じ挙動）
          d.コース編集 = createコース編集(d)

          // 積卸必須チェック
          const 工程情報Valid = 工程情報validate(d)
          isError = 工程情報Valid.hasError === true ? true : isError
          messages.push(工程情報Valid.messages)

          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          if (d.受注部所ID === d.運行部所ID) {
            d.付替区分コード = e付替区分.自部所
          } else {
            d.付替区分コード = e付替区分.他部所
          }
          const 請求内訳 = 請求内訳List?.find(
            (i) => i.荷主請求内訳ID === d.荷主請求内訳ID
          )
          if (請求内訳) {
            // 請求計上日が空白だったら基準日区分に応じた内容を入れる
            if (!d.請求計上日) {
              switch (請求内訳.計上基準日区分名称1) {
                case "PICK日":
                  d.請求計上日 = d.PICK作業日
                  d.車番 = d.PICK車番
                  d.車輌ID = d.PICK車輌ID
                  d.トレーラ車番 = d.PICKトレーラ車番
                  d.トレーラ車輌ID = d.PICKトレーラ車輌ID
                  d.乗務員ID = d.PICK乗務員ID
                  d.乗務員名 = d.PICK乗務員名
                  d.同乗者乗務員ID = d.PICK同乗者ID
                  d.同乗者名 = d.PICK同乗者名
                  break
                case "作業日":
                  d.請求計上日 = d.作業作業日
                  d.車番 = d.作業車番
                  d.車輌ID = d.作業車輌ID
                  d.トレーラ車番 = d.作業トレーラ車番
                  d.トレーラ車輌ID = d.作業トレーラ車輌ID
                  d.乗務員ID = d.作業乗務員ID
                  d.乗務員名 = d.作業乗務員名
                  d.同乗者乗務員ID = d.作業同乗者ID
                  d.同乗者名 = d.作業同乗者名
                  break
                case "返却日":
                  d.請求計上日 = d.返却作業日
                  d.車番 = d.返却車番
                  d.車輌ID = d.返却車輌ID
                  d.トレーラ車番 = d.返却トレーラ車番
                  d.トレーラ車輌ID = d.返却トレーラ車輌ID
                  d.乗務員ID = d.返却乗務員ID
                  d.乗務員名 = d.返却乗務員名
                  d.同乗者乗務員ID = d.返却同乗者ID
                  d.同乗者名 = d.返却同乗者名
                  break
              }
            }
          }
        })
        if (isError) {
          disPatch(setWarningAlerts(messages))
          flexGrid?.refresh()
          return
        }
        const service = new KaikonZyutyuHaisyaService()
        let res: TApiResponse<boolean>
        res = await service.putList(putData)
        disPatch(setAlerts(res))
        if (res) {
          isPrompt.current = false
          showInfoToast(`海コン受注配車リストの更新が完了しました`)
          search(preSearchCondition)
          // setSelectedRows([]) のみだと selectedRows が空になる一方で旧 gridData の dataItem.isSelected が true のまま残り、
          // search 完了（setGridData 全差替え）までの間 setGridReadOnly と formatItem が競合する。
          // 全選択 OFF と同じ要領で dataItem 側も同時にクリアする。
          flexGrid?.rows.forEach((r) => {
            if (r.dataItem != null) {
              r.dataItem.isSelected = false
              r.cssClass = ""
            }
          })
          setSelectedRows([])
        }
      } else {
        showInfoToast(`選択されている行がありません。`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }
  /**
   * グリッド削除
   * @param gridData
   */
  const gridDelete = async () => {
    try {
      const putData: TZyutyuHaisyaListDeleteReq[] = []
      if (selectedRows) {
        for (let row of selectedRows.filter((row) => {
          const item: T海コン受注配車入力GridItem = row.dataItem
          return item.複写フラグ !== 1
        })) {
          const dataItem: TKaikonZyutyuHaisyaListGetRes = row.dataItem
          if (is請求確認済(dataItem)) {
            const messages: string[] = []
            messages.push("請求確認済みのデータは削除できません。")
            disPatch(setWarningAlerts(messages))
            return
          } else {
            putData.push({
              受注配車ID: dataItem.受注配車ID,
              更新日時: dataItem.更新日時!,
            })
          }
        }
      }
      if (putData && putData.length > 0) {
        const service = new KaikonZyutyuHaisyaService()
        let res: TApiResponse<TKaikonZyutyuHaisyaListGetRes[]>
        res = await service.deleteList(putData)
        disPatch(setAlerts(res))
        if (res) {
          isPrompt.current = false
          search()
          showInfoToast(`海コン受注配車リストの削除が完了しました`)
        }
      } else {
        showInfoToast(`選択されている行がありません。`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsDeleteConfirmModalShow(false)
    }
  }

  const checkId = (
    荷主請求s: T表紙分割[],
    請求内訳s: T請求内訳[],
    flexGrid: wjcGrid.FlexGrid
  ) => {
    if (flexGrid == null) return
    const sourceCollection: TKaikonZyutyuHaisyaListGetRes[] =
      flexGrid.collectionView.sourceCollection
    sourceCollection.forEach((rowItem) => {
      if (
        !荷主請求s.find(
          (n) =>
            n.荷主ID === rowItem.荷主ID && n.荷主請求ID === rowItem.荷主請求ID
        )
      ) {
        rowItem.荷主請求ID = undefined
        rowItem.荷主請求内訳ID = undefined
      } else if (
        !請求内訳s.find(
          (n) =>
            n.荷主請求ID === rowItem.荷主請求ID &&
            n.荷主請求内訳ID === rowItem.荷主請求内訳ID
        )
      ) {
        rowItem.荷主請求内訳ID = undefined
      }
    })
  }

  // パターン検索用
  const getPatternItemsSource = (
    query: string,
    max: number,
    callback: (items: TKaikonZyutyuHaisyaPatternListGetRes[]) => void
  ) => {
    if (query == null || wjCore.isNullOrWhiteSpace(query)) {
      callback([])
    } else {
      const service = new KaikonZyutyuHaisyaPatternService()
      service
        .getList({ 受注配車パターンコード: query, 受注部所コード })
        .then((res) => {
          const selectItem = res.data
            ? res.data.map((d) => {
                let displayName = `${d.受注配車パターンコード ?? ""}`
                let detailText = ``
                detailText = commonUtil.addTextWithStartDelimiter(detailText, [
                  d.荷主名,
                ])
                if (detailText !== "") {
                  displayName += `: ${detailText}`
                }
                return { ...d, displayName }
              })
            : []
          callback(selectItem)
        })
    }
  }

  const deleteNewRow = () => {
    if (!contextItem && flexGrid?.itemsSource === undefined) {
    } else {
      const newSelectRows: wjcGrid.Row[] = []
      // 選択状態の保持
      const selectedRowIds = flexGrid?.rows
        .filter(
          (r) =>
            r != null &&
            r.dataItem != null &&
            r.dataItem.row_id != null &&
            r.isSelected
        )
        .map((row) => row.dataItem.row_id)
      flexGrid?.itemsSource.remove(contextItem)
      flexGrid?.rows.forEach((row) => {
        if (
          row.dataItem.row_id == null &&
          contextItem?.row_id === row.dataItem.row_id
        )
          return
        if (selectedRowIds?.find((sr) => sr === row.dataItem.row_id)) {
          newSelectRows.push(row)
          // formatItem (line 1302-) は dataItem.isSelected を判定ソースにしているため、
          // Wijmo Row.isSelected ではなく dataItem 側を更新する必要がある。
          row.dataItem.isSelected = true
        }
      })
      setSelectedRows([...newSelectRows])
    }
    setIsDeleteRowConfirmModalShow(false)
  }

  const 請求車番入力 = (rowItem: TKaikonZyutyuHaisyaListGetRes) => {
    const input請求車番 =
      rowItem.作業車番 ??
      rowItem.その他車番 ??
      rowItem.返却車番 ??
      rowItem.PICK車番 ??
      undefined
    return input請求車番
  }

  const isNot行単位ReadOnly判定 = (
    context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
  ) =>
    !flexGrid?.isReadOnly &&
    !context.row.isReadOnly &&
    context.item.請求額確認区分コード !== e請求支払確認区分.確認済 &&
    context.item.請求処理状態区分コード !== e請求支払処理状態区分.確定 &&
    context.item.請求処理状態区分コード !== e請求支払処理状態区分.送付済

  //#endregion

  //#region [baseState]

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  //アラート制御
  //   const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [effect]

  //初期表示
  useEffect(() => {
    //区分値の確保
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      new TumiorosisakiService().getList({}),
      new SiharaisakiService().getList({}),
      new ZyomuinService().getList({
        退職フラグ: 0,
      }),
    ]).then(
      ([部所ListRes, 区分マスタRes, 積卸先マスタRes, 支払先Res, 乗務員Res]) => {
        setコンテナサイズDataMap(
          new wjcGrid.DataMap(
            区分マスタRes.data.filter(
              (d) =>
                d.分類コード === 区分分類コード.受注配車_請求支払.コンテナサイズ
            ),
            "区分コード",
            "名称1"
          )
        )
        setコンテナ軸DataMap(
          new wjcGrid.DataMap(
            区分マスタRes.data.filter(
              (d) =>
                d.分類コード === 区分分類コード.受注配車_請求支払.コンテナ軸
            ),
            "区分コード",
            "名称1"
          )
        )
        set食事手当区分DataMap(
          new wjcGrid.DataMap(
            区分マスタRes.data.filter(
              (d) => d.分類コード === 区分分類コード.マスタ.食事手当区分
            ),
            "数値1",
            "名称1"
          )
        )
        set課税区分DataMap(
          new wjcGrid.DataMap(
            区分マスタRes.data.filter(
              (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
            ),
            "区分コード",
            "名称1"
          )
        )
        set付帯作業分類区分DataMap(
          new wjcGrid.DataMap(
            区分マスタRes.data.filter(
              (d) =>
                d.分類コード ===
                区分分類コード.受注配車_請求支払.海コン付帯作業区分
            ),
            "区分コード",
            "名称1"
          )
        )

        set付帯作業分類区分List(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード ===
              区分分類コード.受注配車_請求支払.海コン付帯作業区分
          )
        )
        set計上基準日区分DataMap(
          new wjcGrid.DataMap(
            区分マスタRes.data.filter(
              (d) => d.分類コード === 区分分類コード.マスタ.計上基準日区分
            ),
            "区分コード",
            "名称1"
          )
        )

        set配車状態区分DataMap(
          new wjcGrid.DataMap(
            区分マスタRes.data.filter(
              (d) =>
                d.分類コード ===
                  区分分類コード.受注配車_請求支払.配車状態区分 &&
                d.区分コード.match(new RegExp(/2./))
            ),
            "区分コード",
            "名称1"
          )
        )
        // モーダルに設定するため部所一覧を確保
        set部所List(部所ListRes.data)
        if (部所ListRes) {
          set運行部所DataMap(
            new wjcGrid.DataMap(
              部所ListRes.data.filter((d) => d.運行部所フラグ === 1),
              "部所コード",
              "部所略称"
            )
          )
        }

        set支払先DataMap(
          new wjcGrid.DataMap(
            支払先Res.data
              .filter((d) => d.支払先区分コード === e支払先区分.傭車先)
              .map((d) => ({
                ...d,
                displayName: commonUtil.addTextWithStartDelimiter(
                  `${d.支払先コード}:`,
                  [d.支払先略称]
                ),
              })),
            "支払先コード",
            "displayName"
          )
        )

        set積卸先List(積卸先マスタRes.data)
        set乗務員List(乗務員Res.data)
        setIsListGot(true)
      }
    )
  }, [])

  // 初回表紙分割、請求内訳取得用メソッド
  const 初回荷主請求取得 = async (
    検索条件: TKaikonZyutyuHaisyaListGetRes[]
  ) => {
    const 荷主IdList = 検索条件
      .filter((a) => a.荷主ID != null)
      .map((a) => a.荷主ID as number)

    if (荷主IdList.length <= 0) {
      set表紙分割List([])
      return
    }

    try {
      const res = await new NinusiSeikyuService().getList({
        荷主IdList,
        削除済み包含フラグ: true,
      })

      if (res && res.data && res.data.length > 0) {
        set表紙分割List([..._.orderBy(res.data, (a) => a.表紙分割コード)])
      } else {
        set表紙分割List([])
        return
      }
      const 内訳Res = await new NinusiSeikyuService().getListUchiwake({
        荷主請求IdList: [...res.data.map((d) => d.荷主請求ID)],
      })
      if (内訳Res && 内訳Res.data) {
        set請求内訳List([...内訳Res.data])
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  useEffect(() => {
    if (searchResult == null) return
    // 取得したデータより表紙分割と請求内訳を取得
    // 選択行情報も初期化
    setSelectedRows([])
    初回荷主請求取得(searchResult)
      .then(async () => {
        const [車輌Res, 傭車Res] = await Promise.all([
          new SyaryoService().getList({
            廃車フラグ: 0,
          }),
          new YosyaService().getList({}),
        ])
        if (車輌Res.data) {
          const dataMap用車輌list = build車輌DataMapList(車輌Res.data)
          set車輌DataList(dataMap用車輌list)
          const new車番DataMap = new wjcGrid.DataMap(
            dataMap用車輌list,
            "車番",
            "displayName"
          )
          new車番DataMap.getDisplayValues = (
            dataItem: T海コン受注配車入力GridItem
          ) => {
            return dataMap用車輌list.map((h) => h.displayName)
          }
          set車輌DataMap(new車番DataMap)
        }

        if (傭車Res.data) {
          const dataMap用傭車list = 傭車Res.data.map((d) => ({
            ...d,
            displayName: 傭車DisplayNameFunc(d),
          }))
          const new傭車DataMap = new wjcGrid.DataMap(
            dataMap用傭車list,
            "車番",
            "displayName"
          )
          new傭車DataMap.getDisplayValues = (
            dataItem: T海コン受注配車入力GridItem
          ) => {
            const filteredSource = dataMap用傭車list.filter(
              (d) => d.支払先ID === dataItem.支払先ID
            )
            return filteredSource.map((h) => h.displayName)
          }
          set傭車DataMap(new傭車DataMap)
        }

        setGridData({ data: createCollectionView(searchResult, pageSize) })
      })
      .finally(() => {
        flexGrid?.refresh()
        setIsSearching(false)
      })
  }, [searchResult])

  // 荷主コード変更によるdataMap変更用
  useEffect(() => {
    if (flexGrid == null) return
    if (!is荷主コード変更) return
    // 表紙分割Listの更新
    const 表紙分割col = flexGrid.getColumn(
      nameofT<TKaikonZyutyuHaisyaListGetRes>("荷主請求ID")
    )
    // 外部より取得するためにテーブルの荷主コードをすべて取得する
    const tableData: TKaikonZyutyuHaisyaListGetRes[] =
      flexGrid.collectionView.sourceCollection
    const 荷主IdList = tableData
      .map((a) => a.荷主ID as number)
      .filter((a) => a != null)

    if (荷主IdList.length <= 0) {
      if (表紙分割col == null || 表紙分割col.dataMap == null) return
      表紙分割col?.dataMap.collectionView.sourceCollection.splice(
        0,
        表紙分割col?.dataMap.collectionView.sourceCollection.length
      )
      表紙分割col?.dataMap.collectionView.refresh()
      set表紙分割List([])
      setIs荷主コード変更(false)
      return
    }
    const ninusiseikyuService = new NinusiSeikyuService()
    ninusiseikyuService
      .getList({
        荷主IdList,
        削除済み包含フラグ: true,
      })
      .then((荷主請求Res) => {
        if (表紙分割col == null || 表紙分割col.dataMap == null) return
        表紙分割col?.dataMap.collectionView.sourceCollection.splice(
          0,
          表紙分割col?.dataMap.collectionView.sourceCollection.length
        )
        表紙分割col?.dataMap.collectionView.sourceCollection.push(
          ...荷主請求Res.data
        )
        表紙分割col?.dataMap.collectionView.refresh()
        set表紙分割List([...荷主請求Res.data])
        setIs荷主コード変更(false)
      })
      .catch((error) => {
        disPatch(setAlerts(error))
      })
  }, [is荷主コード変更])

  useEffect(() => {
    if (flexGrid == null) return
    // displayNameが一致する場合データ取得内容が曖昧になってしまうのでコード + 名称 + (ID) の表示とする
    util.set表紙分割DataMapFrom荷主コードChanged<
      TKaikonZyutyuHaisyaListGetRes,
      T表紙分割 & { displayMemberPath: string }
    >(
      flexGrid,
      表紙分割List.map((d) => ({
        ...d,
        displayMemberPath: `${d.表紙分割コード}: ${d.表紙名} (${d.荷主請求ID})`,
      })),
      "荷主請求ID",
      "荷主請求ID",
      "displayMemberPath",
      set表紙分割DataMap,
      (h) => h.displayMemberPath
    )

    // 請求内訳Listの更新
    const 請求内訳col = flexGrid.getColumn(
      nameofT<TKaikonZyutyuHaisyaListGetRes>("荷主請求内訳ID")
    )

    const 荷主請求IdList = 表紙分割List.map((a) => a.荷主請求ID)
    if (荷主請求IdList.length <= 0) {
      請求内訳col?.dataMap?.collectionView.sourceCollection.splice(
        0,
        請求内訳col?.dataMap.collectionView.sourceCollection.length
      )
      請求内訳col?.dataMap?.collectionView.refresh()
      set請求内訳List([])
      return
    }

    new NinusiSeikyuService()
      .getListUchiwake({
        荷主請求IdList,
      })
      .then((請求内訳Res) => {
        請求内訳col?.dataMap?.collectionView.sourceCollection.splice(
          0,
          請求内訳col?.dataMap.collectionView.sourceCollection.length
        )
        請求内訳col?.dataMap?.collectionView.sourceCollection.push(
          ...請求内訳Res.data
        )
        請求内訳col?.dataMap?.collectionView.refresh()
        set請求内訳List([...請求内訳Res.data])
      })
  }, [表紙分割List])

  useEffect(() => {
    if (flexGrid == null) return
    // displayNameが一致する場合データ取得内容が曖昧になってしまうのでコード + 名称 + (ID) の表示とする
    util.setDataMapFrom荷主請求Changed<
      TKaikonZyutyuHaisyaListGetRes,
      T請求内訳 & { displayMemberPath: string }
    >(
      flexGrid,
      請求内訳List.map((d) => ({
        ...d,
        displayMemberPath: `${d.請求内訳コード}: ${d.請求内訳名} (${d.荷主請求内訳ID})`,
      })),
      "荷主請求内訳ID",
      "荷主請求内訳ID",
      "displayMemberPath",
      set請求内訳DataMap,
      (h) => h.displayMemberPath
    )
    // 荷主idと荷主請求id、荷主請求内訳idの組み合わせに不備がある場合データを消去
    checkId(表紙分割List, 請求内訳List, flexGrid)
    flexGrid?.refresh()
  }, [請求内訳List])

  useEffect(() => {
    部所List &&
      setSelect受注部所(部所List.find((d) => d.部所コード === 受注部所コード))
  }, [受注部所コード])

  // イベント付替え用のhookに格納する
  const cellEditEndedHandler = useGridEventHandler(
    flexGrid?.cellEditEnded,
    cellEditEnded
  )
  const pastedCellHandler = useGridEventHandler(
    flexGrid?.pastedCell,
    pastedCell
  )
  const cellEditEndingHandler = useGridEventHandler(
    flexGrid?.cellEditEnding,
    cellEditEnding
  )

  //ファンクション内部のstate更新のためイベント付け替え
  useEffect(() => {
    if (isListGot && flexGrid) {
      cellEditEndedHandler.refresh()
      pastedCellHandler.refresh()
      cellEditEndingHandler.refresh()
    }
  }, [請求内訳List, 積卸先List, 車輌DataList, isListGot])

  useEffect(() => {
    if (isGridRefresh) {
      flexGrid?.refresh()
      setIsGridRefresh(false)
    }
  }, [isGridRefresh])

  // 登録ボタン制御用
  // 登録ボタンが押せるのは選択行が存在するか、新規追加行が存在するときのみ
  useEffect(() => {
    if (flexGrid == null) {
      setIsDisabled登録ボタン(true)
      return
    }
    const gridRow: T海コン受注配車入力GridItem[] =
      flexGrid.collectionView.sourceCollection
    // 一行も存在しない場合入力不可
    if (gridRow.length <= 0) {
      setIsDisabled登録ボタン(true)
      return
    }
    // 受注部所未選択の場合入力不可
    if (受注部所コード == null || 受注部所コード === "") {
      setIsDisabled登録ボタン(true)
      return
    }
    // 選択行が存在しない場合入力不可
    if (isSearching || selectedRows == null || selectedRows.length <= 0) {
      setIsDisabled登録ボタン(true)
      return
    }
    setIsDisabled登録ボタン(false)
  }, [isSearching.valueOf, selectedRows, 受注部所コード, flexGrid])

  useEffect(() => {
    if (flexGrid == null || searchResult == null) return

    setGridReadOnly(flexGrid)
  }, [flexGrid, selectedRows, searchResult])
  useEffect(() => {
    if (flexGrid == null || gridData == null) return
    setGridReadOnly(flexGrid)
  }, [gridData])

  const setGridReadOnly = (flexGrid: wjcGrid.FlexGrid) => {
    if (selectedRows == null) {
      flexGrid.rows.forEach((r) => (r.isReadOnly = true))
    } else {
      flexGrid.rows.forEach((row: wjcGrid.Row) => {
        const dataItem = row.dataItem as T海コン受注配車入力GridItem

        if (
          selectedRows.find((r) => {
            const selectRowData = r.dataItem as T海コン受注配車入力GridItem
            return selectRowData.row_id === dataItem.row_id
          })
        ) {
          if (
            // 請求支払確認区分が未登録か未確認の時のみisReadOnlyをTrueにする
            dataItem.請求額確認区分コード === e請求支払確認区分.未確認 ||
            dataItem.請求額確認区分コード == null
          ) {
            row.isReadOnly = false
          } else {
            row.isReadOnly = true
          }
        } else {
          row.isReadOnly = true
        }
      })
    }
    if (selectedRows != null && selectedRows.length > 0) {
      flexGrid.isReadOnly = false
    } else {
      flexGrid.isReadOnly = true
    }
    flexGrid.refresh()
  }

  useEffect(() => {
    // 一度でも選択状態の行ができたらtrueにする
    if (!isPrompt.current && selectedRows.length > 0) {
      isPrompt.current = true
      setForceUpdate(!forceUpdate)
    }
  }, [selectedRows])

  // 休日リストの取得は画面内で一度のみのため
  // 休日リスト取得でエベントを付与し、それ以降動かないようにする
  const [hadGet休日List, setHadGet休日List] = useState(false)
  useEffect(() => {
    if (休日List != null && 休日List.length > 0 && !hadGet休日List) {
      flexGrid?.formatItem.addHandler(formatItem)
      flexGrid?.beginningEdit.addHandler(beginningEdit)
      setHadGet休日List(true)
    }
  }, [休日List])
  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <input
        type="check"
        style={{ display: "none" }}
        value={forceUpdate ? 0 : 1}
        onChange={(e) => {
          setForceUpdate(e.currentTarget.checked)
        }}></input>
      <FlexGridOuter
        flexGrid={flexGrid}
        setFlexGrid={setFlexGrid}
        gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        gridData={gridData}
        setGridData={setGridData}
        pageNumber={pageNumber}
        excelFormatItem={kaikonExcelFormat}
        searchConditionClear={props.searchConditionClear}
        gridId={props.gridId}
        isRestoreSearching={isRestoreSearching}
        isEnablePageSize={"hidden"}
        setIsRestoreSearching={setIsRestoreSearching}
        gridInitialized={gridInitialized}
        setGridInitialized={setGridInitialized}
        pageSize={pageSize}
        setPageSize={setPageSize}
        gridInitializedHandler={gridInitializedHandler}
        gridProperties={{
          frozenColumns: 6,
          isReadOnly: true,
          allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
          headersVisibility: wjcGrid.HeadersVisibility.All,
          keyActionTab: wjcGrid.KeyAction.CycleOut,
        }}
        headerComponent={
          <>
            <Button
              disabled={
                isSearching || selectedRows == null || selectedRows.length <= 0
              }
              onClick={() => {
                setIs複写Modal(true)
              }}>
              <FontAwesomeIcon icon={faPlusSquare} />
              複写
            </Button>
            <Button
              disabled={
                isSearching || 受注部所コード == null || 受注部所コード === ""
              }
              onClick={() => {
                addRow()
              }}>
              <FontAwesomeIcon icon={faPlusSquare} />
              行追加
            </Button>
            <span>
              <Link
                to={`${受注配車入力PathList[0]}`}
                onClick={(e) => {
                  if (isSearching) {
                    e.preventDefault()
                    e.stopPropagation()
                  }
                  gridPageHelper.savePageConditionData(location.pathname)
                }}>
                <Button
                  variant="primary"
                  className="mx-1"
                  disabled={isSearching}>
                  <FontAwesomeIcon icon={faPlusSquare} />
                  海コン受注配車入力
                </Button>
              </Link>
            </span>
            <Button
              className="w-7rem"
              disabled={isDisabled登録ボタン}
              variant="waiting"
              onClick={() => {
                beforeSubmit()
              }}>
              登録
            </Button>
            <Button
              disabled={
                isSearching || selectedRows == null || selectedRows.length !== 1
              }
              variant="waiting"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIs海コン受注配車パターン新規登録Modal(true)
              }}>
              海コンパターン登録
            </Button>
            <Button
              style={{ marginLeft: "10rem" }}
              variant="caution"
              onClick={() => {
                if (
                  isSearching ||
                  selectedRows == null ||
                  selectedRows.length <= 0
                ) {
                  showInfoToast(`選択されている行がありません。`)
                } else {
                  setIsDeleteConfirmModalShow(true)
                }
              }}
              disabled={
                isSearching || selectedRows == null || selectedRows.length <= 0
              }>
              選択行削除
            </Button>
          </>
        }>
        <wjrGrid.FlexGridCellTemplate
          cellType={wjrGrid.CellTemplateType.TopLeft}
          template={(
            context: TWijmoCellTemplateContext<T海コン受注配車入力GridItem>
          ) => {
            const grid = context.row.grid
            const checked =
              grid.rows.length > 0 && selectedRows.length === grid.rows.length
            return (
              <div>
                {context.row.index !== 0 && (
                  <input
                    checked={checked}
                    onChange={(e) => {
                      const rows = grid.rows
                      if (checked) {
                        rows.forEach((r) => {
                          r.dataItem.isSelected = false
                          r.cssClass = ""
                        })
                        setSelectedRows([])
                      } else {
                        rows.forEach((r) => {
                          r.dataItem.isSelected = true
                          r.cssClass = "edit-row"
                        })
                        setSelectedRows([...rows])
                      }
                    }}
                    type="checkbox"></input>
                )}
              </div>
            )
          }}></wjrGrid.FlexGridCellTemplate>
        <wjrGrid.FlexGridCellTemplate
          cellType={wjrGrid.CellTemplateType.RowHeader}
          template={(
            context: TWijmoCellTemplateContext<T海コン受注配車入力GridItem>
          ) => {
            const checked = context.item.isSelected
            return context.item.複写フラグ === 1 ? (
              <></>
            ) : (
              <div>
                <input
                  checked={checked}
                  onChange={(e) => {
                    if (checked) {
                      context.row.dataItem.isSelected = false
                      context.row.cssClass = ""
                      setSelectedRows([
                        ...selectedRows.filter(
                          (row) => row.dataItem.row_id !== context.item.row_id
                        ),
                      ])
                    } else {
                      context.row.dataItem.isSelected = true
                      context.row.cssClass = "edit-row"
                      setSelectedRows([...selectedRows, context.row])
                    }
                  }}
                  type="checkbox"></input>
              </div>
            )
          }}></wjrGrid.FlexGridCellTemplate>
        <wjrGrid.FlexGridColumn
          variant="waiting"
          header="編集"
          cssClassAll={"read-only-cell"}
          allowDragging={false}
          hasFilter={false}
          allowSorting={false}
          binding="受注配車id"
          allowMerging={true}
          selectable={false}
          align="center"
          width={60}
          isReadOnly>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<T海コン受注配車入力GridItem>
            ) => {
              if (context.item.複写フラグ) {
                return (
                  <Button
                    type="button"
                    variant="caution"
                    className="btn btn-small btn-primary move-edit-page"
                    onClick={(e) => {
                      e.preventDefault()
                      setContextItem(context.item)
                      setIsDeleteRowConfirmModalShow(true)
                    }}>
                    削除
                  </Button>
                )
              } else {
                return (
                  <Button
                    type="button"
                    className="btn btn-small btn-primary move-edit-page"
                    onClick={() => {
                      // 画面全体のスクロール位置の保存
                      gridPageHelper.savePageConditionData(location.pathname)
                      history.push(
                        受注配車入力PathList[1].replaceAll(
                          ":id",
                          context.item.受注配車ID.toString()
                        )
                      )
                    }}>
                    編集
                  </Button>
                )
              }
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受注No"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={110}
          header="受注No">
          <wjrGrid.FlexGridCellTemplate
            cellType={wjrGrid.CellTemplateType.ColumnHeader}
            template={() => (
              <div style={{ height: "100%" }}>受注No</div>
            )}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        {/* パターン検索 */}
        <wjrGrid.FlexGridColumn
          binding="受注配車パターンコード"
          width={120}
          isRequired={false}
          header="パターンCD"
          editor={
            new wjcInput.AutoComplete(document.createElement("div"), {
              minLength: 2,
              isRequired: false,
              itemsSourceFunction: getPatternItemsSource,
              displayMemberPath: "displayName",
              selectedValuePath: "受注配車パターンコード",
            })
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.受注配車パターンコード}
                  </div>
                  {isNot行単位ReadOnly判定(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          setモーダル検索用荷主コード(context.item.荷主コード)
                          setモーダル検索用荷主名(context.item.荷主名)
                          set選択行(context.row)
                          setIs海コン受注配車パターン検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        {/* 荷主 */}
        <wjrGrid.FlexGridColumn
          binding="荷主コード"
          width={80}
          isRequired={false}
          header="荷主CD"
          editor={
            new wjcInput.AutoComplete(document.createElement("div"), {
              minLength: 2,
              isEditable: true,
              delay: 300,
              itemsSourceFunction: (
                query: string,
                max: number,
                callback: wjcInput.IGetItemsCallback
              ) => {
                return get荷主ItemsSourceByApi(query, max, callback)
              },
              displayMemberPath: "displayName",
              selectedValuePath: "荷主コード",
            })
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.荷主コード}</div>
                  {isNot行単位ReadOnly判定(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          setIs荷主検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主略称1"
          width={200}
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          header="荷主名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主請求ID"
          width={120}
          isRequired={false}
          dataMap={表紙分割DataMap}
          header="表紙名"></wjrGrid.FlexGridColumn>
        {/* オーダー情報 */}
        <wjrGrid.FlexGridColumn
          binding="オーダー内容"
          width={120}
          isRequired={false}
          header="内容"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="オーダー備考"
          width={120}
          isRequired={false}
          header="備考"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="オーダー指定時間"
          width={100}
          isRequired={false}
          header="指定時間"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主依頼番号"
          width={120}
          isRequired={false}
          header="荷主依頼No"></wjrGrid.FlexGridColumn>
        {/* コンテナ情報 */}
        <wjrGrid.FlexGridColumn
          binding="コンテナNO"
          width={120}
          isRequired={false}
          header="NO"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="コンテナサイズコード"
          width={80}
          isRequired={false}
          dataMap={コンテナサイズDataMap}
          header="サイズ"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="コンテナ軸コード"
          width={80}
          isRequired={false}
          dataMap={コンテナ軸DataMap}
          header="軸"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="配車状態区分コード"
          width={100}
          isRequired={false}
          dataMap={配車状態区分DataMap}
          header="作業状態"></wjrGrid.FlexGridColumn>
        {/* PICK */}
        <wjrGrid.FlexGridColumn
          binding="PICK作業日"
          width={90}
          isRequired={false}
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              format: "MM/dd",
            })
          }
          format={"d"}
          header="PICK日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              let dt = ""
              if (context.item.PICK作業日)
                dt = dayjs(context.item.PICK作業日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK作業時間"
          width={100}
          isRequired={false}
          header="時間"></wjrGrid.FlexGridColumn>

        <wjrGrid.FlexGridColumn
          binding="PICKカット日"
          width={120}
          isRequired={false}
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              format: "MM/dd",
            })
          }
          format={"d"}
          header="フリータイム">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              let dt = ""
              if (context.item.PICKカット日)
                dt = dayjs(context.item.PICKカット日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>

        <wjrGrid.FlexGridColumn
          binding="PICK積卸先コード"
          width={100}
          isRequired={false}
          header="積卸先CD"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              積卸先AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.PICK積卸先コード}
                  </div>
                  {isNot行単位ReadOnly判定(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          set工程検索対象("PICK")
                          setモーダル検索用荷主コード(context.item.荷主コード)
                          setIs積卸先検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK積卸先名称"
          isRequired={false}
          header="ヤード"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK積卸先市区町村"
          isRequired={false}
          header="地名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK積卸先都道府県"
          isRequired={false}
          header="都道府県"></wjrGrid.FlexGridColumn>
        {/* PICK車輌 */}
        <wjrGrid.FlexGridColumn
          binding="PICK運行部所コード"
          dataMap={運行部所DataMap}
          width={100}
          isRequired={false}
          header="運行部所"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK傭車フラグ"
          header="傭車利用"
          dataType={wjCore.DataType.Boolean}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK支払先コード"
          width={100}
          isRequired={false}
          header="傭車CD"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              傭車CDAutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.PICK傭車フラグ
                      ? context.item.支払先コード
                      : ""}
                  </div>
                  {isNot行単位ReadOnly判定(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          set工程検索対象("PICK")
                          setIs傭車先検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK傭車会社名"
          isReadOnly={true}
          header="傭車会社">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.PICK傭車フラグ ? context.item.傭車会社名 : ""}
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK車番"
          sortMemberPath={"paddingPICK車番"}
          width={80}
          header="車番"
          isRequired={false}
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              PICKヘッド車輌AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item?.PICK車番}</div>
                  {isNot行単位ReadOnly判定(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={PICKヘッド車輌検索ModalButtonClickHandler(
                          context
                        )}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICKトレーラ車番"
          sortMemberPath={"paddingPICKトレーラ車番"}
          width={90}
          header="トレーラ"
          isRequired={false}
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              PICKトレーラ車輌AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.PICKトレーラ車番}
                  </div>
                  {isNot行単位ReadOnly判定(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={PICKトレーラ車輌検索ModalButtonClickHandler(
                          context
                        )}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        {/* <wjrGrid.FlexGridColumn
          binding="PICK乗務員ID"
          isRequired={false}
          isReadOnly={true}
          width={120}
          header="乗務員"
        /> */}
        <wjrGrid.FlexGridColumn
          binding="PICK乗務員名"
          isRequired={false}
          width={120}
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              PICK乗務員AutoCompleteProperties
            )
          }
          header="乗務員">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.PICK乗務員名}</div>
                  {isNot行単位ReadOnly判定(context) &&
                    context.item.PICK傭車フラグ !== 1 && (
                      <div className="text-end">
                        <a
                          href="*"
                          onClick={(e) => {
                            e.preventDefault()
                            set選択行(context.row)
                            set工程検索対象("PICK")
                            set乗務員検索対象("乗務員")
                            setIs乗務員検索Modal(true)
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                        </a>
                      </div>
                    )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK乗務員売上額"
          width={100}
          isRequired={false}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="乗務員売上"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK海コン付帯高速料"
          width={100}
          isRequired={false}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="付帯高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK乗務員食事手当"
          isRequired={false}
          width={100}
          format="n0"
          align="right"
          dataMap={食事手当区分DataMap}
          header="食事手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK同乗者名"
          width={120}
          isRequired={false}
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              PICK同乗者AutoCompleteProperties
            )
          }
          header="同乗者">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.PICK同乗者名}</div>
                  {isNot行単位ReadOnly判定(context) &&
                    context.item.PICK傭車フラグ !== 1 && (
                      <div className="text-end">
                        <a
                          href="*"
                          onClick={(e) => {
                            e.preventDefault()
                            set選択行(context.row)
                            set工程検索対象("PICK")
                            set乗務員検索対象("同乗者")
                            setIs乗務員検索Modal(true)
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                        </a>
                      </div>
                    )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK付帯作業区分コード"
          isRequired={false}
          dataMap={付帯作業分類区分DataMap}
          width={120}
          header="付帯作業分類"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK付帯作業手当"
          isRequired={false}
          width={120}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="付帯作業手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK工程備考"
          isRequired={false}
          width={120}
          header="備考"></wjrGrid.FlexGridColumn>
        {/* 作業 */}
        <wjrGrid.FlexGridColumn
          binding="作業作業日"
          isRequired={false}
          width={90}
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              format: "MM/dd",
            })
          }
          format={"d"}
          header="作業日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              let dt = ""
              if (context.item.作業作業日)
                dt = dayjs(context.item.作業作業日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業作業時間"
          width={100}
          isRequired={false}
          header="時間"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業積卸先コード"
          isRequired={false}
          width={100}
          header="積卸先CD"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              積卸先AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.作業積卸先コード}
                  </div>
                  {isNot行単位ReadOnly判定(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          set工程検索対象("作業")
                          set車輌検索用原動機有無フラグ(1)
                          setモーダル検索用荷主コード(context.item.荷主コード)
                          setIs積卸先検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="作業積卸先名称"
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="作業積卸先市区町村"
          header="地名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業積卸先都道府県"
          isRequired={false}
          header="都道府県"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業内容"
          isRequired={false}
          width={120}
          header="作業内容"></wjrGrid.FlexGridColumn>
        {/* 作業車両 */}
        <wjrGrid.FlexGridColumn
          binding="作業運行部所コード"
          dataMap={運行部所DataMap}
          width={100}
          header="運行部所"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業傭車フラグ"
          header="傭車利用"
          dataType={wjCore.DataType.Boolean}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="作業支払先コード"
          width={100}
          header="傭車CD"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              傭車CDAutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.作業傭車フラグ
                      ? context.item.支払先コード
                      : ""}
                  </div>
                  {isNot行単位ReadOnly判定(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          set工程検索対象("作業")
                          setIs傭車先検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業傭車会社名"
          isReadOnly={true}
          header="傭車会社">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.作業傭車フラグ ? context.item.傭車会社名 : ""}
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="作業車番"
          sortMemberPath={"padding作業車番"}
          width={80}
          header="車番"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              作業ヘッド車輌AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.作業車番}</div>
                  {isNot行単位ReadOnly判定(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={作業ヘッド車輌検索ModalButtonClickHandler(
                          context
                        )}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="作業トレーラ車番"
          sortMemberPath={"padding作業トレーラ車番"}
          width={90}
          header="トレーラ"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              作業トレーラ車輌AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.作業トレーラ車番}
                  </div>
                  {isNot行単位ReadOnly判定(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={作業トレーラ車輌検索ModalButtonClickHandler(
                          context
                        )}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業乗務員名"
          isRequired={false}
          width={120}
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              作業乗務員AutoCompleteProperties
            )
          }
          header="乗務員">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.作業乗務員名}</div>
                  {isNot行単位ReadOnly判定(context) &&
                    context.item.作業傭車フラグ !== 1 && (
                      <div className="text-end">
                        <a
                          href="*"
                          onClick={(e) => {
                            e.preventDefault()
                            set選択行(context.row)
                            set工程検索対象("作業")
                            set乗務員検索対象("乗務員")
                            setIs乗務員検索Modal(true)
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                        </a>
                      </div>
                    )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="作業乗務員売上額"
          width={100}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="乗務員売上"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業海コン付帯高速料"
          width={100}
          isRequired={false}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="付帯高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="作業乗務員食事手当"
          width={100}
          format="n0"
          dataMap={食事手当区分DataMap}
          header="食事手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業同乗者名"
          width={120}
          isRequired={false}
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              作業同乗者AutoCompleteProperties
            )
          }
          header="同乗者">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.作業同乗者名}</div>
                  {isNot行単位ReadOnly判定(context) &&
                    context.item.作業傭車フラグ !== 1 && (
                      <div className="text-end">
                        <a
                          href="*"
                          onClick={(e) => {
                            e.preventDefault()
                            set選択行(context.row)
                            set工程検索対象("作業")
                            set乗務員検索対象("同乗者")
                            setIs乗務員検索Modal(true)
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                        </a>
                      </div>
                    )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業付帯作業区分コード"
          isRequired={false}
          dataMap={付帯作業分類区分DataMap}
          width={120}
          header="付帯作業分類"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業付帯作業手当"
          width={120}
          isRequired={false}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="付帯作業手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業工程備考"
          isRequired={false}
          width={120}
          header="備考"></wjrGrid.FlexGridColumn>
        {/* 返却 */}
        <wjrGrid.FlexGridColumn
          binding="返却作業日"
          width={90}
          isRequired={false}
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              format: "MM/dd",
            })
          }
          format={"d"}
          header="返却日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              let dt = ""
              if (context.item.返却作業日)
                dt = dayjs(context.item.返却作業日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却作業時間"
          width={100}
          isRequired={false}
          header="時間"></wjrGrid.FlexGridColumn>

        <wjrGrid.FlexGridColumn
          binding="返却カット日"
          width={100}
          isRequired={false}
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              format: "MM/dd",
            })
          }
          format={"d"}
          header="カット">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              let dt = ""
              if (context.item.返却カット日)
                dt = dayjs(context.item.返却カット日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>

        <wjrGrid.FlexGridColumn
          binding="返却積卸先コード"
          width={100}
          isRequired={false}
          header="積卸先CD"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              積卸先AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.返却積卸先コード}
                  </div>
                  <div className="text-end">
                    <a
                      href="*"
                      onClick={(e) => {
                        e.preventDefault()
                        set選択行(context.row)
                        set工程検索対象("返却")
                        setモーダル検索用荷主コード(context.item.荷主コード)
                        setIs積卸先検索Modal(true)
                      }}>
                      <FontAwesomeIcon icon={faSearch} />
                    </a>
                  </div>
                  {/* )} */}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却積卸先名称"
          isRequired={false}
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却積卸先市区町村"
          isRequired={false}
          header="地名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却積卸先都道府県"
          isRequired={false}
          header="都道府県"></wjrGrid.FlexGridColumn>
        {/* 返却車両 */}
        <wjrGrid.FlexGridColumn
          binding="返却運行部所コード"
          isRequired={false}
          dataMap={運行部所DataMap}
          width={100}
          header="運行部所"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却傭車フラグ"
          header="傭車利用"
          dataType={wjCore.DataType.Boolean}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却支払先コード"
          isRequired={false}
          width={100}
          header="傭車CD"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              傭車CDAutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.返却傭車フラグ
                      ? context.item.支払先コード
                      : ""}
                  </div>
                  <div className="text-end">
                    <a
                      href="*"
                      onClick={(e) => {
                        e.preventDefault()
                        set選択行(context.row)
                        set工程検索対象("返却")
                        setIs傭車先検索Modal(true)
                      }}>
                      <FontAwesomeIcon icon={faSearch} />
                    </a>
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却傭車会社名"
          isReadOnly={true}
          header="傭車会社">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.返却傭車フラグ ? context.item.傭車会社名 : ""}
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却車番"
          isRequired={false}
          sortMemberPath={"padding返却車番"}
          width={80}
          header="車番"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              返却ヘッド車輌AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.返却車番}</div>
                  <div className="text-end">
                    <a
                      href="*"
                      onClick={返却ヘッド車輌検索ModalButtonClickHandler(
                        context
                      )}>
                      <FontAwesomeIcon icon={faSearch} />
                    </a>
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却トレーラ車番"
          sortMemberPath={"padding返却トレーラ車番"}
          isRequired={false}
          width={90}
          header="トレーラ"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              返却トレーラ車輌AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.返却トレーラ車番}
                  </div>
                  <div className="text-end">
                    <a
                      href="*"
                      onClick={返却トレーラ車輌検索ModalButtonClickHandler(
                        context
                      )}>
                      <FontAwesomeIcon icon={faSearch} />
                    </a>
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却乗務員名"
          isRequired={false}
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              返却乗務員AutoCompleteProperties
            )
          }
          width={120}
          header="乗務員">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.返却乗務員名}</div>
                  {context.item.返却傭車フラグ !== 1 && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          set工程検索対象("返却")
                          set乗務員検索対象("乗務員")
                          setIs乗務員検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却乗務員売上額"
          isRequired={false}
          width={100}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="乗務員売上"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却海コン付帯高速料"
          width={100}
          isRequired={false}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="付帯高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却乗務員食事手当"
          isRequired={false}
          width={100}
          format="n0"
          dataMap={食事手当区分DataMap}
          header="食事手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却同乗者名"
          isRequired={false}
          width={120}
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              返却同乗者AutoCompleteProperties
            )
          }
          header="同乗者">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.返却同乗者名}</div>
                  {context.item.返却傭車フラグ !== 1 && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          set工程検索対象("返却")
                          set乗務員検索対象("同乗者")
                          setIs乗務員検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却付帯作業区分コード"
          dataMap={付帯作業分類区分DataMap}
          isRequired={false}
          width={120}
          header="付帯作業分類"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却付帯作業手当"
          isRequired={false}
          width={120}
          cssClass="number-col"
          format="n0"
          dataType={wjCore.DataType.Number}
          header="付帯作業手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却工程備考"
          isRequired={false}
          width={120}
          header="備考"></wjrGrid.FlexGridColumn>
        {/* その他 */}
        <wjrGrid.FlexGridColumn
          binding="その他作業日"
          isRequired={false}
          width={90}
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              format: "MM/dd",
            })
          }
          format={"d"}
          header="日付">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              let dt = ""
              if (context.item.その他作業日)
                dt = dayjs(context.item.その他作業日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他作業時間"
          width={100}
          isRequired={false}
          header="時間"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他積卸先コード"
          width={100}
          header="積卸先CD"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              積卸先AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.その他積卸先コード}
                  </div>
                  <div className="text-end">
                    <a
                      href="*"
                      onClick={(e) => {
                        e.preventDefault()
                        set選択行(context.row)
                        set工程検索対象("その他")
                        setモーダル検索用荷主コード(context.item.荷主コード)
                        setIs積卸先検索Modal(true)
                      }}>
                      <FontAwesomeIcon icon={faSearch} />
                    </a>
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他積卸先名称"
          isRequired={false}
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他積卸先市区町村"
          isRequired={false}
          header="地名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他積卸先都道府県"
          isRequired={false}
          header="都道府県"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他作業内容"
          isRequired={false}
          width={120}
          header="作業内容"></wjrGrid.FlexGridColumn>
        {/* その他車両 */}
        <wjrGrid.FlexGridColumn
          binding="その他運行部所コード"
          isRequired={false}
          dataMap={運行部所DataMap}
          width={100}
          header="運行部所"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他傭車フラグ"
          header="傭車利用"
          dataType={wjCore.DataType.Boolean}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他支払先コード"
          isRequired={false}
          width={100}
          header="傭車CD"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              傭車CDAutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.その他傭車フラグ
                      ? context.item.支払先コード
                      : ""}
                  </div>
                  <div className="text-end">
                    <a
                      href="*"
                      onClick={(e) => {
                        e.preventDefault()
                        set選択行(context.row)
                        set工程検索対象("その他")
                        setIs傭車先検索Modal(true)
                      }}>
                      <FontAwesomeIcon icon={faSearch} />
                    </a>
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他傭車会社名"
          isReadOnly={true}
          header="傭車会社">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.その他傭車フラグ
                      ? context.item.傭車会社名
                      : ""}
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他車番"
          isRequired={false}
          sortMemberPath={"paddingその他車番"}
          width={80}
          header="車番"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              その他ヘッド車輌AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.その他車番}</div>
                  <div className="text-end">
                    <a
                      href="*"
                      onClick={その他ヘッド車輌検索ModalButtonClickHandler(
                        context
                      )}>
                      <FontAwesomeIcon icon={faSearch} />
                    </a>
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他トレーラ車番"
          isRequired={false}
          sortMemberPath={"paddingその他トレーラ車番"}
          width={90}
          header="トレーラ"
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              その他トレーラ車輌AutoCompleteProperties
            )
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.その他トレーラ車番}
                  </div>
                  <div className="text-end">
                    <a
                      href="*"
                      onClick={その他トレーラ車輌検索ModalButtonClickHandler(
                        context
                      )}>
                      <FontAwesomeIcon icon={faSearch} />
                    </a>
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他乗務員名"
          isRequired={false}
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              その他乗務員AutoCompleteProperties
            )
          }
          width={120}
          header="乗務員">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.その他乗務員名}
                  </div>
                  {context.item.その他傭車フラグ !== 1 && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          set工程検索対象("その他")
                          set乗務員検索対象("乗務員")
                          setIs乗務員検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他乗務員売上額"
          isRequired={false}
          width={100}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="乗務員売上"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他海コン付帯高速料"
          width={100}
          isRequired={false}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="付帯高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他乗務員食事手当"
          isRequired={false}
          width={100}
          dataMap={食事手当区分DataMap}
          format="n0"
          header="食事手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他同乗者名"
          isRequired={false}
          editor={
            new wjcInput.AutoComplete(
              document.createElement("div"),
              その他同乗者AutoCompleteProperties
            )
          }
          width={120}
          header="同乗者">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    {context.item.その他同乗者名}
                  </div>
                  {context.item.その他傭車フラグ !== 1 && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          set工程検索対象("その他")
                          set乗務員検索対象("同乗者")
                          setIs乗務員検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他付帯作業区分コード"
          dataMap={付帯作業分類区分DataMap}
          isRequired={false}
          width={120}
          header="付帯作業分類"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他付帯作業手当"
          isRequired={false}
          width={120}
          format="n0"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="付帯作業手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他工程備考"
          isRequired={false}
          width={120}
          header="備考"></wjrGrid.FlexGridColumn>
        {/* 請求 */}
        <wjrGrid.FlexGridColumn
          binding="荷主請求内訳ID"
          width={150}
          isRequired={false}
          dataMap={請求内訳DataMap}
          header="請求内訳"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求区分名称1"
          width={150}
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          header="請求区分"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求車番"
          isRequired={false}
          width={100}
          header="請求車番"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isReadOnly={true}
          isRequired={false}
          binding="履歴検索"
          width={80}
          header="履歴">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              return (
                <a
                  href="*"
                  onClick={(e) => {
                    e.preventDefault()
                    // setSelectRow(context.row)
                    // setIsModalShow(true)
                  }}>
                  {/* 実装したらcolor={"gray"}を消す */}
                  <FontAwesomeIcon icon={faSearch} color={"gray"} />
                </a>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          width={70}
          binding="請求運送料課税区分コード"
          isRequired={false}
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求運送料"
          isRequired={false}
          cssClass="number-col"
          width={100}
          format="n0"
          dataType={wjCore.DataType.Number}
          header="運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          width={70}
          isRequired={false}
          binding="請求付帯料課税区分コード"
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求付帯料"
          isRequired={false}
          isReadOnly={true}
          width={100}
          format="n0"
          cssClass="number-col"
          cssClassAll={"read-only-cell"}
          dataType={wjCore.DataType.Number}
          header="付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          width={70}
          isRequired={false}
          binding="請求高速料税込区分名称1"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="込/抜"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求高速料"
          isRequired={false}
          isReadOnly={true}
          width={100}
          format="n0"
          cssClass="number-col"
          cssClassAll={"read-only-cell"}
          dataType={wjCore.DataType.Number}
          header="高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求合計"
          width={80}
          format="n0"
          cssClass="number-col"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          isRequired={false}
          header="合計"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          width={80}
          binding="計上基準日区分コード"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          isRequired={false}
          dataMap={計上基準日区分DataMap}
          header="基準日"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          width={90}
          binding="請求計上日"
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              format: "yyyyMMdd",
              placeholder: "yyyymmdd",
            })
          }
          format={"d"}
          isRequired={false}
          header="計上日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              let dt = ""
              if (context.item.請求計上日)
                dt = dayjs(context.item.請求計上日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求備考"
          width={150}
          isRequired={false}
          header="請求備考"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求額確認区分名称1"
          isRequired={false}
          cssClass={"read-only-cell"}
          isReadOnly={true}
          header="請求額確認"></wjrGrid.FlexGridColumn>
        {/* 支払 */}
        <wjrGrid.FlexGridColumn
          binding="支払運送料"
          width={100}
          format="n0"
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払付帯料"
          width={100}
          format="n0"
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払高速料"
          width={100}
          format="n0"
          isRequired={false}
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払合計"
          width={100}
          format="n0"
          cssClass="number-col"
          isRequired={false}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="合計"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払計上日"
          isRequired={false}
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              format: "yyyyMMdd",
              placeholder: "yyyymmdd",
            })
          }
          format={"d"}
          header="支払計上日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaListGetRes>
            ) => {
              let dt = ""
              if (context.item.支払計上日)
                dt = dayjs(context.item.支払計上日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払備考"
          width={150}
          isRequired={false}
          header="支払備考"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受領書有無フラグ"
          dataMap={受領書DataMap}
          width={80}
          header="有無"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="bl受領書確認フラグ"
          dataType={wjCore.DataType.Boolean}
          width={80}
          header="確認"></wjrGrid.FlexGridColumn>
        {/* 海コン追加項目（KAIROS-1107） */}
        <wjrGrid.FlexGridColumn
          binding="船社"
          width={120}
          isRequired={false}
          header="船社"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="BLBK"
          width={120}
          isRequired={false}
          header="B/L・B/K"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="本船名"
          width={150}
          isRequired={false}
          header="本船名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="VOY"
          width={100}
          isRequired={false}
          header="VOY"></wjrGrid.FlexGridColumn>
      </FlexGridOuter>

      {/* モーダル */}
      {/* 複写 */}
      <ModalOuter
        size="lg"
        setIsShow={setIs複写Modal}
        isShow={is複写Modal}
        title="複写"
        footer={
          <>
            <Button
              onClick={(e) => {
                複写(e, "枝番")
                setIs複写Modal(false)
              }}>
              枝番として複写する
            </Button>
            <Button
              onClick={(e) => {
                複写(e, "別受注")
                setIs複写Modal(false)
              }}>
              別受注で複写する
            </Button>
          </>
        }>
        <div>以下の受注Noを複写します</div>
        <ul>
          {selectedRows
            ?.filter((row) => {
              const item: T海コン受注配車入力GridItem = row.dataItem
              return item.複写フラグ !== 1
            })
            .map((row: wjcGrid.Row) => {
              const item: T海コン受注配車入力GridItem = row.dataItem
              return <li key={item.受注伝票番号}>{item.受注伝票番号}</li>
            })}
        </ul>
      </ModalOuter>
      {/* 海コン受注配車パターン新規登録 */}
      <KaikonZyutyuHaisyaPatternRegisterModal
        isShow={is海コン受注配車パターン新規登録Modal}
        setIsShow={setIs海コン受注配車パターン新規登録Modal}
        data={
          selectedRows != null && selectedRows.length > 0
            ? selectedRows[0].dataItem
            : undefined
        }></KaikonZyutyuHaisyaPatternRegisterModal>
      {/* 荷主検索 */}
      <NinusiSeikyuSearchModal
        isShow={is荷主検索Modal}
        setIsShow={setIs荷主検索Modal}
        ninusiName={モーダル検索用荷主名}
        setNinusi={(荷主請求) => {
          if (選択行 == null || 選択行.dataItem == null) return
          const casted: T海コン受注配車入力GridItem = 選択行.dataItem
          casted.荷主ID = 荷主請求.荷主ID
          casted.荷主コード = 荷主請求.荷主コード
          casted.荷主名 = 荷主請求.荷主名
          casted.荷主略称1 = 荷主請求.荷主略称1
          casted.荷主請求ID = parseInt(荷主請求.表紙分割コード)
          casted.表紙名 = 荷主請求.表紙名
          if (!casted.荷主依頼番号) {
            casted.荷主依頼番号 = 荷主請求.荷主依頼番号接頭辞
          }
          casted.新規編集フラグ = false
          setIs荷主コード変更(true)
          flexGrid?.refresh()
        }}></NinusiSeikyuSearchModal>
      {/* 海コン受注配車パターン検索 */}
      <KaikonZyutyuHaisyaPatternModal
        isShow={is海コン受注配車パターン検索Modal}
        setIsShow={setIs海コン受注配車パターン検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        ninusiName={モーダル検索用荷主名}
        zyutyubusyo={select受注部所}
        zyutyubusyoCode={受注部所コード}
        setPattern={async (海コン受注配車パターン) => {
          if (選択行 == null || 選択行.dataItem == null) return
          const casted: T海コン受注配車入力GridItem = 選択行.dataItem
          await setPattern(海コン受注配車パターン, casted)
          setIs荷主コード変更(true)
          flexGrid?.refresh()
        }}></KaikonZyutyuHaisyaPatternModal>
      {/* 積卸先検索 */}
      <TumiOrosiSakiSearchModal
        size="lg"
        setIsShow={setIs積卸先検索Modal}
        isShow={is積卸先検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        setTumiOrosiSaki={(積卸先) => {
          if (選択行 && 選択行.dataItem) {
            const casted: TKaikonZyutyuHaisyaListGetRes = 選択行.dataItem
            switch (工程検索対象) {
              case "PICK":
                casted.PICK積卸先ID = 積卸先.積卸先ID
                casted.PICK積卸先コード = 積卸先.積卸先コード
                casted.PICK積卸先名称 = 積卸先.積卸先略称
                casted.PICK積卸先都道府県 = 積卸先.住所１ ?? ""
                casted.PICK積卸先市区町村 = 積卸先.住所２ ?? ""
                break
              case "作業":
                casted.作業積卸先ID = 積卸先.積卸先ID
                casted.作業積卸先コード = 積卸先.積卸先コード
                casted.作業積卸先名称 = 積卸先.積卸先略称
                casted.作業積卸先都道府県 = 積卸先.住所１ ?? ""
                casted.作業積卸先市区町村 = 積卸先.住所２ ?? ""
                break
              case "返却":
                casted.返却積卸先ID = 積卸先.積卸先ID
                casted.返却積卸先コード = 積卸先.積卸先コード
                casted.返却積卸先名称 = 積卸先.積卸先略称
                casted.返却積卸先都道府県 = 積卸先.住所１ ?? ""
                casted.返却積卸先市区町村 = 積卸先.住所２ ?? ""
                break
              case "その他":
                casted.その他積卸先ID = 積卸先.積卸先ID
                casted.その他積卸先コード = 積卸先.積卸先コード
                casted.その他積卸先名称 = 積卸先.積卸先略称
                casted.その他積卸先都道府県 = 積卸先.住所１ ?? ""
                casted.その他積卸先市区町村 = 積卸先.住所２ ?? ""
                break
              default:
                break
            }

            flexGrid?.refresh()
          }
        }}></TumiOrosiSakiSearchModal>
      {/* 車輌検索 */}
      <SyaryoSearchModal
        setIsShow={(v) => {
          setIs車輌検索Modal(v)
        }}
        isShow={is車輌検索Modal}
        busyoCode={全部所車番検索Enabled ? undefined : 車輌検索用部所コード}
        原動機有無フラグ={車輌検索用原動機有無フラグ}
        setSyaryo={(車輌) => {
          const casted: T海コン受注配車入力GridItem = 選択行?.dataItem
          if (車輌検索対象 === "車輌") {
            castヘッド車輌(casted, 車輌, 工程検索対象)
          } else {
            castトレーラ車輌(casted, 車輌, 工程検索対象)
          }
          flexGrid?.refresh()
        }}></SyaryoSearchModal>
      {/* 傭車検索 */}
      <YosyaSearchModal
        setIsShow={setIs傭車検索Modal}
        isShow={is傭車検索Modal}
        isReadOnly={true}
        yosyaSakiCode={車輌検索用傭車会社コード}
        setYosya={傭車検索結果Set}></YosyaSearchModal>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T海コン受注配車入力GridItem = 選択行.dataItem
            cast乗務員(casted, 乗務員, 乗務員検索対象, 工程検索対象)
            flexGrid?.refresh()
          }
        }}></ZyomuinSearchModal>
      {/* 傭車先検索 */}
      <SiharaisakiSearchModal
        siharaisakiKubun={"傭車先"}
        isShow={is傭車先検索Modal}
        setIsShow={setIs傭車先検索Modal}
        setSiharaisaki={(支払先) => {
          if (選択行 && 選択行.dataItem) {
            const casted: TKaikonZyutyuHaisyaListGetRes = 選択行.dataItem
            casted.支払先ID = 支払先.支払先ID
            casted.支払先コード = 支払先.支払先コード
            casted.傭車会社名 = 支払先.支払先名

            switch (工程検索対象) {
              case "PICK":
                casted.PICK傭車フラグ = 1
                break
              case "作業":
                casted.作業傭車フラグ = 1
                break
              case "返却":
                casted.返却傭車フラグ = 1
                break
              case "その他":
                casted.その他傭車フラグ = 1
                break
              default:
                break
            }
            // 作業日が入っている場合、支払計上日を入力する
            if (casted.作業作業日 != null && casted.作業作業日 !== "") {
              casted.支払計上日 = casted.作業作業日
            }
            flexGrid?.refresh()
          }
        }}></SiharaisakiSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={gridRegister}>
        入力された内容で更新しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isDeleteConfirmModalShow}
        hideHandler={setIsDeleteConfirmModalShow}
        submitHandler={gridDelete}>
        選択行を削除しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isDeleteRowConfirmModalShow}
        hideHandler={setIsDeleteRowConfirmModalShow}
        submitHandler={deleteNewRow}>
        追加した行を削除しますか？
      </ConfirmModal>
      {/* 受注請求履歴検索 */}
      {/* 運賃タリフ検索 */}
      {/* 運賃タリフ検索　AGCロジ高速料 */}
      {/* ETC高速料 */}
    </>
  )
}

export default ZyutyuHaisyaListGrid
